<template>
  <div class="busi-modelDetail">
      <!-- <el-card class="box-card model-top" shadow="always"> -->
        <div class="model-top">
          <div class="tit">
             <font size="5" >{{formInfo.modelName}}</font>
          </div>
          <div  class="btns" v-if="!isView"  style="margin-left:10px;">
            <span  v-if="!hideAllBtn" style="margin-right:10px;">
                <!-- <el-tooltip class="item" effect="light" content="用于显示该表单的审批执行状态" placement="top">
                    <el-checkbox  v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " class="checkBox-style" v-model="approvalStatusRecord"  @change="handleApprovalDetail"><el-tag size="mini">审批执行状态</el-tag></el-checkbox>
                </el-tooltip> -->
                <el-popover
                placement="bottom"
                trigger="click">
                    <el-image
                        :key="imageKey"
                        style="width: 100px; height: 100px; margin-left: 24px;"
                        :src="qrUrl"
                        fit="fill"></el-image>
                <el-button slot="reference" size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''&&!resourceForm" icon="iconfont icon-other-ico" @click.stop="showQR(form)">{{qrTit}}</el-button>
                </el-popover>
                <el-button size="mini" v-if="!isAddForm" icon="el-icon-view" @click.stop="showRight">审批/修改记录</el-button>
                <!-- <el-button size="mini" v-if="!isAddForm" icon="el-icon-view" @click.stop="handleShowFormDataUpdRecordList()">查看修改记录</el-button> -->
                <!-- <el-tooltip class="item" effect="light" content="查看关于当前数据的所有审批记录" placement="top">
                    <el-button size="mini" v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!==''" icon="el-icon-view" @click.stop="handleShowApprovalRecordList(index)">查看全部审批记录</el-button>
                </el-tooltip> -->
                <el-button size="mini" v-if="durlist && durlist.length>0" icon="el-icon-view" @click.stop="handleFromDataFilter(0,form)">查看待还款数据</el-button>
                <el-button size="mini" v-if="(isAddForm || isShowCopyHis) &&!resourceForm" icon="el-icon-document-copy" @click.stop="handleSelectFromHis(0,form)">复制数据</el-button>
                <el-button size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''&&!resourceForm" icon="el-icon-download" @click.stop="exportExcelData(index)">导出</el-button>
                <el-button size="mini" v-if="(isAddForm&&isShowStartApprovalBtn) || (!isView&&!(currentRowData!=null&&currentRowData.hasOwnProperty('approvalInstanceId')&&currentRowData.approvalInstanceId!=''&& currentRowData.isCanEdit)&&!resourceForm)" icon="el-icon-circle-plus" @click.stop="handleStartApproval(index)">发起审批</el-button>
                <el-button size="mini" icon="el-icon-printer" @click.stop="handlePrint(0)">打印</el-button>
                <el-button size="mini" v-if="isViewSubFormViewBtn" icon="el-icon-monitor" @click.stop="handleSubFormView(0)">切换子表单显示</el-button>
                <el-tooltip class="item" effect="light" content="以卡片模式的方式展开查看关于当前表单配置的关联表单数据" placement="top">
                    <el-button size="mini" v-if="showCardModelBtn" icon="el-icon-connection" @click.stop="viewCardModel(0)">卡片模式</el-button>
                </el-tooltip>
                <!-- <el-button v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " size="mini" icon="el-icon-printer" @click.stop="handlePrintApprove(index)">审批流打印</el-button> -->
            </span>
            <div class="btns" v-if="hideAllBtn">
                <el-button size="mini" v-if="showDiagram && processInstanceId!='' "  title='流程图' circle icon="el-icon-picture-outline" @click.stop="handelShowDiagram(formData[0])"></el-button>
            </div>
            <div v-if="isShowSaveBtn">
                <el-button v-if="formBtnAuth && formBtnAuth.isShowEdit && currentRowData!=null && currentRowData.isCanEdit" type="primary"  icon="el-icon-edit-outline" v-preventReClick = "3000" @click="handleModelComplete">保存数据</el-button>
                <el-button v-if="currentRowData!=null && currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " type="success"  icon="el-icon-view"   @click="handleView">审批详情</el-button>
                <el-button v-if="currentRowData!=null && currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!==''&& isShowDown" type="success"  icon="el-icon-download"  @click="exportExcelData">导出数据</el-button>
                <el-button v-if="formBtnAuth && formBtnAuth.isShowDelete && currentRowData!=null && currentRowData.isCanDelete" type="danger"  icon="el-icon-delete"  @click="handleModelFormDelete" style="margin-left:10px;">删除</el-button>
                <el-button v-if="!isShowSaveBtn && isShowForm" type="primary" icon="el-icon-back" @click="switchAddFormData()">返回数据列表</el-button>
            </div>
            <div v-if="isAddForm || resourceForm" >
                <el-button type="primary" icon="el-icon-edit-outline"  @click="handleModelComplete" v-preventReClick = "3000">保存数据</el-button>
                <el-button v-if="isShowForm && !hideRetListBtn" type="primary"  icon="el-icon-back" @click="switchAddFormData()">返回数据列表</el-button>
            </div>
          </div>
          <div v-if="isView"  class="btns">
            <el-button class="btn-style"  icon="el-icon-download" type="primary" title="导出excel" @click="dataExport()">导出excel</el-button>
          </div>
        </div>
      <!-- </el-card> -->

      <div class="model-content">
          <div class="content-left"  v-if="isShowForm">
             <div v-for="(form, index) in forms" :key="form.id" :name="form.id">
              <!-- <el-card class="box-card" shadow="always"> -->
                  <!-- <el-collapse  style="height:100%;overflow-y:auto;"  v-if="isShowForm" v-model="collapseActiveName" accordion>
                      <el-collapse-item class="collapseItem" v-for="(form, index) in forms" :key="form.id" :name="form.id"> -->
                          <template slot="title">
                              <div class='el-collapse-title'>
                                  <span></span>
                                  <div class="btns" v-if="!hideAllBtn">
                                      <el-tooltip class="item" effect="light" content="用于显示该表单的审批执行状态" placement="top">
                                          <el-checkbox  v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' " class="checkBox-style" v-model="approvalStatusRecord"  @change="handleApprovalDetail"><el-tag size="mini">审批执行状态</el-tag></el-checkbox>
                                      </el-tooltip>
                                      <el-popover
                                        placement="bottom"
                                        trigger="click">
                                          <el-image
                                               :key="imageKey"
                                               style="width: 100px; height: 100px; margin-left: 24px;"
                                               :src="qrUrl"
                                               fit="fill"></el-image>
                                        <el-button slot="reference" size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''&&!resourceForm" icon="iconfont icon-other-ico" @click.stop="showQR(form)">{{qrTit}}</el-button>
                                      </el-popover>
                                      <!-- <el-button size="mini" v-if="!isAddForm" icon="el-icon-view" @click.stop="showRight">查看审批/修改记录</el-button> -->
                                      <el-tooltip class="item" effect="light" content="查看关于当前数据的所有审批记录" placement="top">
                                          <el-button size="mini" v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!==''" icon="el-icon-view" @click.stop="handleShowApprovalRecordList(index)">查看全部审批记录</el-button>
                                      </el-tooltip>
                                      <el-button size="mini" v-if="durlist && durlist.length>0" icon="el-icon-view" @click.stop="handleFromDataFilter(index,form)">查看待还款数据</el-button>
                                      <el-button size="mini" v-if="(isAddForm || isShowCopyHis) &&!resourceForm" icon="el-icon-document-copy" @click.stop="handleSelectFromHis(index,form)">复制数据</el-button>
                                      <el-button size="mini" v-if="!isView&&currentRowData!=null&&currentRowData.hasOwnProperty('id')&&currentRowData.id!=''&&!resourceForm" icon="el-icon-download" @click.stop="exportExcelData(index)">导出</el-button>
                                      <el-button size="mini" v-if="(isAddForm&&isShowStartApprovalBtn) || (!isView&&!(currentRowData!=null&&currentRowData.hasOwnProperty('approvalInstanceId')&&currentRowData.approvalInstanceId!=''&& currentRowData.isCanEdit)&&!resourceForm)" icon="el-icon-circle-plus" @click.stop="handleStartApproval(index)">发起审批</el-button>
                                      <el-button size="mini" icon="el-icon-printer" @click.stop="handlePrint(index)">打印</el-button>
                                      <el-button size="mini" v-if="isViewSubFormViewBtn" icon="el-icon-monitor" @click.stop="handleSubFormView(index)">切换子表单显示</el-button>
                                      <el-tooltip class="item" effect="light" content="以卡片模式的方式展开查看关于当前表单配置的关联表单数据" placement="top">
                                         <el-button size="mini" v-if="showCardModelBtn" icon="el-icon-connection" @click.stop="viewCardModel(index)">卡片模式</el-button>
                                      </el-tooltip>
                                  </div>
                                  <div class="btns" v-if="hideAllBtn">
                                      <el-button size="mini" v-if="showDiagram && processInstanceId!='' "  title='流程图' circle icon="el-icon-picture-outline" @click.stop="handelShowDiagram(formData[index])"></el-button>
                                  </div>
                              </div>
                          </template> 
                          <!-- <ul> -->
                          <el-form :model="formData[index].values" :ref="'customForm'+index" label-width="256px" :id="`print${form.id}`">
                              <div :key="loadTimerField" >
                                  <!--审批记录-->
                                  <!-- <template>
                                      <div v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' && approvalStatusRecord">
                                          <el-divider content-position="left">审批执行状态</el-divider>
                                          <el-row>
                                              <el-steps v-if="approvalDetail.approvalMethod != 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                                                  <el-step v-for="(item, index) in approvalDetail.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('description')?item.description:''"></el-step>
                                              </el-steps>
                                              <el-steps v-if="approvalDetail.approvalMethod == 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                                                  <el-step v-for="(item, index) in approvalDetail.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('description')?item.description:''">
                                                      <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(approvalDetail.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                                          <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                                      </el-breadcrumb>
                                                  </el-step>
                                              </el-steps>
                                          </el-row>
                                          <el-divider content-position="left"></el-divider>
                                      </div>
                                  </template> -->
                                  <!-- 模式3  -->
                                  <template v-for="(field,index2) in form.fieldsList" >
                                      <template v-if="isShowNormalField(field,index,formData[index])">
                                      <FieldItem
                                          :key="field.fieldId"
                                          :findex="index2"
                                          :ref="'fieldItemChild'+index2"
                                          :formId="form.id"
                                          :formConfig="form"
                                          :field="field"
                                          :isRead="field.isRead || isRead"
                                          :isView="field.isView"
                                          :formData="formData[index].values"
                                          :colSpan="form.colSpan"
                                          :taskInstance="taskInstance"
                                          :processModelFormsObj="processModelFormsObj"
                                          :processInstance="processInstance"
                                          :fieldsList="form.fieldsList"
                                          :formBtnAuth="formBtnAuth"
                                          :parentFormInfo="formInfo"
                                          :parentFormDataArr="formData"
                                          :mainInstanceId="id"
                                          :linkFieldCache="linkFieldCache"
                                          :relateModelList="relateModelList"
                                          :approvalStatus="approvalDetail.approvalStatus"
                                          :isManageMode="isManageMode"
                                          @loadLinkData="loadLinkData"
                                          @loadDeptField="loadDeptField"
                                          @refreshViewField="refreshViewField"
                                          @asynMainFormData="asynMainFormData"
                                          @asynFormUserFieldData="asynFormUserFieldData"
                                          @dealSpecialField="dealSpecialField"
                                      />
                                      </template>
                                  </template>
                                  <div class="render-form-item" style="width: 100%; float: left;" v-if="(formData[index].values['subFormViewMode']!==0 && formData[index].ext1===1) || (formData[index].values['subFormViewMode'] && (formData[index].values['subFormViewMode'] > 0))">
                                  <el-row>
                                      <el-form-item label="" style="width: 100%;">
                                      <el-tabs :key="loadTimerField" v-model="defaultViewOrder" >
                                          <template v-for="(field,index2) in form.fieldsList" >
                                              <template v-if="field.type === 'subform' && isShowCascadeField(field, formData[index].values)" >
                                              <el-tab-pane   :key="index2" :label="getSubformName(formData[index].values,field)" :name="index2+''">
                                                  <FieldItem
                                                      :key="field.fieldId"
                                                      :findex="index2"
                                                      :ref="'fieldItemChild'+index2"
                                                      :formId="form.id"
                                                      :formConfig="form"
                                                      :field="field"
                                                      :isRead="field.isRead || isRead"
                                                      :isView="field.isView"
                                                      :formData="formData[index].values"
                                                      :colSpan="form.colSpan"
                                                      :taskInstance="taskInstance"
                                                      :processModelFormsObj="processModelFormsObj"
                                                      :processInstance="processInstance"
                                                      :fieldsList="form.fieldsList"
                                                      :subFormViewMode="1"
                                                      :formBtnAuth="formBtnAuth"
                                                      :parentFormInfo="formInfo" 
                                                      :parentFormDataArr="formData"
                                                      :mainInstanceId="id"
                                                      :linkFieldCache="linkFieldCache"
                                                      :relateModelList="relateModelList"
                                                      :approvalStatus="approvalDetail.approvalStatus"
                                                      :isManageMode="isManageMode"
                                                      @loadLinkData="loadLinkData"
                                                      @loadDeptField="loadDeptField"
                                                      @refreshViewField="refreshViewField"
                                                      @asynMainFormData="asynMainFormData"
                                                      @asynFormUserFieldData="asynFormUserFieldData"
                                                      @dealSpecialField="dealSpecialField"
                                                  />
                                              </el-tab-pane>
                                              </template>
                                          </template>
                                      </el-tabs>
                                      </el-form-item>
                                  </el-row>
                                  </div>
                              </div>
                              <!-- 关联的其他表单数据 -->
                              <div class="render-form-item" v-if="showRelateFormTab" style="width: 100%; float: left;">
                                  <el-row>
                                      <el-form-item class="relateFormTab" label="" style="width: 100%;">
                                      <el-tabs :key="loadTimerRelate" @tab-click="handleRelateFormTabClick" v-model="relateFormTabName" >
                                          <template v-for="(model, index3) in relateModelList" >
                                              <el-tab-pane :key="model.id" :label="model.modelName" :name="model.id" v-if="!model.hiddenElement">
                                                  <RelateFormList
                                                      :ref="'relateModelList' + model.id"
                                                      :key="loadTimerRelate"
                                                      :selectedModel="model"
                                                      :tempFormData="tempFormData"
                                                      :parentFormInfo="formInfo"
                                                      :parentFormData="formData"
                                                      @refTempFormData="refTempFormData"
                                                  />
                                              </el-tab-pane>
                                          </template>
                                      </el-tabs>
                                      </el-form-item>
                                  </el-row>
                              </div>
                          </el-form>
                        </div>
                          <!-- </ul> -->
                      <!-- </el-collapse-item>
                  </el-collapse> -->
              <!-- </el-card> -->
          </div>
          <div class="content-switch" v-if="!isAddForm">
            <img src="~assets/img/price/switch.png" v-if="!isShowRight" style="border-radius:20px;height:70px;position: fixed;cursor: pointer;top:50%;margin-left:-4px;" @click="showRight" :class="isShowRight?'content-right-open':'content-right-close'">
            <img src="~assets/img/price/switch_close.png" v-if="isShowRight" style="border-radius:20px;height:70px;position: fixed;cursor: pointer;top:50%;margin-left:-4px;" @click="showRight" :class="isShowRight?'content-right-open':'content-right-close'">
          </div>
          <div class="content-right" v-if="isShowRight">
            <div class="content-right-tit">
                <div class="tit-approve" :class="rightActive===1 ? 'activeTit':''"   @click="handleApprovalDetail">
                    <div>审批执行状态</div>
                    <div class="line"></div>
                </div>
                <div class="tit-uprecord" :class="rightActive===2 ? 'activeTit':''" @click.stop="handleShowFormDataUpdRecordList">
                    <div>修改记录</div>
                    <div class="line"></div>
                </div>
            </div>
            <div class="content-right-content">
                <div class="content-approve" v-if="rightActive===1">
                   <div class="approve-title"><span @click="handleView">{{approvalDetail.approvalName}}</span></div>
                   <div v-if="currentRowData.hasOwnProperty('approvalInstanceId') && currentRowData.approvalInstanceId!=='' && approvalStatusRecord" class="approve-info">
                        <el-steps v-if="approvalDetail.approvalMethod < 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success" direction="vertical" :space="80">
                            <el-step v-for="(item, index) in approvalDetail.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('description')?item.description:''"></el-step>
                        </el-steps>
                        <el-steps v-if="approvalDetail.approvalMethod > 1 && approvalDetail.approvalTotalNum>0" align-center finish-status="success" direction="vertical" :space="80">
                            <el-step v-for="(item, index) in approvalDetail.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('description')?item.description:''">
                                <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(approvalDetail.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}&nbsp;&nbsp;{{user.description}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                  </div>
                </div>
                <div class="content-uprecord" v-if="rightActive===2">
                    <div class="uprecord-item" v-for="(item,index) in updRecordList" :key="index">
                        <div class="left">
                            <div class="dot"></div>
                            <div class="line"></div>
                        </div>
                        <div class="right">
                            <div class="item-bottom">
                                <div class="top"></div>
                                <div class="bottom">
                                    <div class="item-top">
                                        <div class="upUser">修改人：{{item.createdTrueName}}</div>
                                        <div class="upTime">{{item.created}}</div>
                                    </div>
                                    <div class="item-content">
                                        {{item.updContent}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
      <el-dialog
          title="表单打印确认页"
          append-to-body
          top="4vh"
          :fullscreen=true
          :visible.sync="isShowPrintUtil">
          <PrintUtil :key="loadTimer" ref="printUtil" :formInfo="printForm"  />
      </el-dialog>
       <el-dialog
          title="审批打印确认页"
          append-to-body
          top="4vh"
          :fullscreen=true
          :visible.sync="isShowApproval">
          <PrintUtilApprove :key="loadTimer" ref="printUtilApprove" :formInfo="printForm"  :isShowApproval="true" />
      </el-dialog>

      <el-dialog
          title="审批模板选择页"
          append-to-body
          top="4vh"
          :fullscreen=true
          :visible.sync="isShowApprovalTemplatePop">
          <ApprovalTemplate :key="loadTimer" ref="approvalTemplate"
              :formInfo="approvalForm"
              :startApproval="true"
              :selectedTemplate="selectedTemplate"
              :isReturnToNav="isReturnToNav"
              @handleNavPage="handleNavPage"/>
      </el-dialog>
      <!-- 显示图标 -->
      <el-dialog
          title="流程图"
          width="80%"
          append-to-body
          :fullscreen=true
          :visible.sync="isShowDiagram"
          custom-class="diagram-dialog">
          <ProcessDiagram
            ref="diagrams"
            :processInstance="instances"
            :taskList="taskList"
            :archiveTemplateTreeList="archiveTemplateTreeList"
          />
      </el-dialog>
      <el-dialog
          title="表单数据选择"
          width="80%"
          top="4vh"
          append-to-body
          :visible.sync="isShowDataCopyDialog">
          <TableDataPop
              ref="tableDataPop"
              :key="loadTimer"
              :modelId="currentModelId"
              @reloadFormData="reSetProcessFormData"
              >
          </TableDataPop>
      </el-dialog>
      <el-dialog
          title="未还款的表单数据"
          width="80%"
          top="4vh"
          append-to-body
          :visible.sync="isShowDataFilterDialog">
          <TableDataPop
              ref="tableDataFilterPop"
              :key="loadTimer"
              :isApprovalFilter="true"
              :modelId="currentModelId"
              >
          </TableDataPop>
      </el-dialog>
      <el-dialog
          title="审批记录"
          width="80%"
          top="4vh"
          append-to-body
          :visible.sync="isShowApprovalRecordListDialog">
          <ApprovalRecordList
              ref="approvalRecordListPop"
              :key="loadTimer"
              :modelInstanceId="currentModeInstanceId"
              >
          </ApprovalRecordList>
      </el-dialog>
      <el-dialog
          title="数据修改记录"
          width="80%"
          top="4vh"
          append-to-body
          :visible.sync="isShowFormDataUpdRecordListDialog">
          <FormDataUpdRecordList
              ref="formDataUpdRecordListPop"
              :key="loadTimer"
              :modelInstanceId="currentModeInstanceId"
              >
          </FormDataUpdRecordList>
      </el-dialog>
      <!-- <el-dialog
          title="添加定位中心"
          top="4vh"
          width="50vw"
          :visible.sync="active"
          v-if="active"
          append-to-body>
          <LocationConfig
              ref="detailRef"
              :locationInfo="locationInfo"
              @configLocationArray="configLocationArray"
              @hideSidebox="hideSidebox"/>
      </el-dialog> -->
      <el-dialog
          title="表单卡片列表"
          top="1vh"
          width="80%"
          :key="cardLoadTimer"
          :fullscreen=true
          append-to-body
          :visible.sync="isShowForms">
          <ProcessForms   :processInfo="processInfo" :isFormCardModel="true" :cardFormId="cardFormId" :cardInstanceId="cardInstanceId"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowForms=false">取 消</el-button>
          </span>
      </el-dialog>
       <FieldValidation  ref="fieldValidation"/>
  </div>
</template>

<script>
  import { isEmpty, clone, cloneDeep } from 'lodash';
  import { API_EXPORT_MODEL_TITLE_FORM_EXCEL } from '@/common/constants';
  import { getSerialNumberDepAndOption, getModelFormInstanceApprovalDurList, getApprovalInstanceDetail, getModelListByMainFormId, getSerialNumber, getSerialNumberDepartment, getModeInstanceProcessDetail, getFormDataUpdRecordBOList,
      getProcessInstancesDetail, getAllUserTask, getArchiveTemplateTreeList, getModelFormInstanceQR, getCrossFieldData, saveAppModelForm, getSerialNumberPlus, getModelFormReportList, getFormConfig, getModelFormInstanceById } from '@/data-model';
  import PrintUtil from '@/components/PrintUtil';
  import PrintUtilApprove from '@/components/PrintUtil/PrintUtilApprove';
  import ApprovalTemplate from '@/pages/process/ProcessTemplate/ApprovalTemplate.vue';
  import RelateFormList from '@/pages/business/BusinessApplication/RelateFormList.vue';
  import TableDataPop from '@/components/TableDataPop';
  import FieldValidation from '@/components/Formula/FieldValidation.vue';
  import ProcessForms from '@/pages/process/MyProcess/ProcessForms';
  import mixinsNav from '@/mixins/mixins-nav';
  import { getUUID, objectKeyIsEmpty } from '@/utils/grocer';
  import { isFormFieldVisible, isRequiredFormFieldVisible, resetCascadeFieldVisible } from '@/utils/form-required';
  export default {
      components: {
          RelateFormList,
          TableDataPop,
          PrintUtil,
          PrintUtilApprove,
          ApprovalTemplate,
          FieldValidation,
          ProcessForms
      },
      mixins: [ mixinsNav ],
      data () {
          return {
              isShowFormDataUpdRecordListDialog: false,
              currentModeInstanceId: '',
              isShowApprovalRecordListDialog: false,
              durlist: [], // 逾期未还款数据列表
              isShowDataFilterDialog: false,
              approvalDetail: {},
              approvalStatusRecord: true,
              tempFormData: [], // 将要新增的关联表单数据
              showRelateFormTab: false,
              relateFormTabName: '',
              loadTimerRelate: '',
              relateModelList: [], // 关联的表单
              defaultViewOrder: null,
              selectedTemplate: [],
              currentModelId: '',
              formIndex: 0, // 多表单时，用于重置表单数据
              isShowDataCopyDialog: false,
              isShowDiagram: false,
              instances: {},
              taskList: [],
              archiveTemplateTreeList: [],
              isAddForm: false,
              loadTimer: '',
              loadTimerField: '',
              isShowPrintUtil: false,
              isShowPrintForm: false,
              isShowApproval: false,
              isDetailShowForm: this.isShowForm,
              collapseActiveName: '',
              formData: [],
              modelName: '',
              isShowStartApprovalBtn: false, // 发起审批按钮
              isShowSaveBtn: false,
              formBtnAuth: {},
              currentRowData: {id: '', approvalInstanceId: ''},
              isShowDown: false,
              printForm: {},
              isShowApprovalTemplatePop: false,
              approvalForm: {},
              id: '',
              qrUrl: '',
              qrTit: '生成二维码',
              imageKey: '',
              isViewSubFormViewBtn: false,
              setTim: [],
              isTimer: true,
              linkFieldCache: new Map(),
              relateModelMap: new Map(),
              searchParams: {
                  modelId: '',
                  name: '',
                  selectedFields: '',
                  searchCondition: []
              },
              searchCondition: [],
              defaultConditonsMap: new Map(), // 默认设置关联数据的过滤条件map
              searchConditionExt: [],
              isShowForms: false,
              cardLoadTimer: '',
              processInfo: {},
              cardFormId: '',
              cardInstanceId: '',
              showCardModelBtn: false,
              rightActive: 1,
              isShowRight: false,
              updRecordList: [],
              isManageMode: false // 是否应用数据管理模式，true的话放开只读字段
          };
      },
      props: {
          formInfo: {
              type: Object
          },
          processInstanceId: {
              type: String,
              default: ''
          },
          isShowCopyHis: {
              type: Boolean,
              default: false
          },
          isShowForm: {
              type: Boolean,
              default: false
          },
          resourceForm: {
              type: Boolean,
              default: false
          },
          isRead: {
              type: Boolean,
              default: false
          },
          isView: {
              type: Boolean,
              default: false
          },
          showDiagram: {// 显示流程图
              type: Boolean,
              default: false
          },
          hideAllBtn: {
              type: Boolean,
              default: false
          },
          isReturnToNav: {// 为发起审批成功后，判断来自于新交互模式还是旧模式，默认旧模式
              type: Boolean,
              default: false
          },
          taskInstance: {
              type: Object
          },
          processInstance: {
              type: Object
          },
          processModelFormsObj: {
              type: Array
          },
          hideRetListBtn: {// 隐藏返回列表按钮
              type: Boolean,
              default: false
          }
      },
      watch: {
          'relateModelList' (newVal, oldVal) {
              if (newVal && newVal.length > 0) {
                  for (let i = 0; i < newVal.length; i++) {
                      let cur = newVal[i];
                      if (oldVal && oldVal.length > 0) {
                          let res = oldVal.find(element => element.id === cur.id);
                          if (res.hiddenElement) {
                              cur.hiddenElement = res.hiddenElement;
                          } else {
                              cur.hiddenElement = false;
                          }
                      }
                  }
              }
              if (this.relateModelList && this.relateModelList.length > 0) {
                  for (let i = 0; i < this.relateModelList.length; i++) {
                      let cur = this.relateModelList[i];
                      if (!cur.hiddenElement) {
                          this.relateFormTabName = cur.id;
                          this.showRelateFormTab = true;
                          this.renderModelFormList(cur);
                          break;
                      }
                  }
              }
          }
      },
      mounted () {
          this.$nextTick(() => {
              // let formInfo = this.formInfo.formObj.structure[0];
              // if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
              //     this.loadTimerField = new Date().getTime();
              //     for (var i = 0; i < formInfo.fieldsList.length; i++) {
              //         let tempField = formInfo.fieldsList[i];
              //         let tempRefName = 'fieldItemChild' + i;
              //         if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
              //             setTimeout(() => {
              //                 // 设置下拉字段级联默认显示数据
              //                 if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
              //                     this.$refs[tempRefName][0].initDefaultCasData();
              //                 }
              //             }, 0);
              //         }
              //         if (!this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
              //             this.defaultViewOrder = i + '';
              //             this.isViewSubFormViewBtn = true;// 显示子表单模式切换按钮
              //         }
              //         if (tempField.type === 'user') {
              //             setTimeout(() => {
              //                 // 设置下拉字段级联默认显示数据
              //                 if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
              //                     this.$refs[tempRefName][0].setUserExtCascadeData(true);
              //                 }
              //             }, 0);
              //         }
              //     }
              // }
              this.linkFieldCache = new Map();
              this.initFormStructure();
              // 补充加载触发显示子表数据
              if (!this.relateModelList || this.relateModelList.length < 1) {
                  this.getModelListByMainFormId(true);
              } else {
                  this.showRelateFormTab = true;
                  // 默认打开第一个关联表单数据
                  this.relateFormTabName = this.relateModelList[0].id;
                  // console.log(this.relateModelList[0]);
                  this.renderModelFormList(this.relateModelList[0]);
              }
          });
      },
      computed: {
          forms () {
              if (isEmpty(this.formInfo.formObj)) {
                  return [];
              } else {
                  this.formInfo.formObj.structure[0].fieldsList.forEach(element => {
                      // 处理权限字段
                      if (element.options && element.options.ext2) {
                          let curObj = JSON.parse(element.options.ext2);
                          element.formFieldAuth = curObj.formFieldAuth;
                          element.approveFieldAuth = curObj.approveFieldAuth;
                      }
                  });
                  return this.formInfo.formObj.structure;
              }
          },
          sidebarOpened () {
              return this.appState.sidebar.opened;
          }
      },
      created () {
          this.isTimer = true;
          this.$emit('setIsShowForm', false);
          if (this.formInfo.formObj.instance) {
              let instance = JSON.parse(this.formInfo.formObj.instance);
              if (instance.qrpath) {
                  this.qrTit = '二维码';
              }
          }
          if (this.formInfo.formObj.structure[0]) {
              let cur = this.formInfo.formObj.structure[0];
              if (cur.realTimeSave && this.isView == false) { // 配置了自动保存
                  let realTime = cur.realTime;
                  this.setRealTimeSaveData(realTime);
              }
              this.getModelFormInstanceApprovalDurList();
              if (cur.dataShowConfig) {
                  let dataShowConfig = JSON.parse(cur.dataShowConfig);
                  if (dataShowConfig.relateShowCardModelConfig) {
                      this.showCardModelBtn = true;
                  }
              }
          }
      },
      methods: {
          async getModelFormInstanceApprovalDurList () {
              // console.log(this.formInfo);
              this.durlist = await getModelFormInstanceApprovalDurList({'formId': this.formInfo.formId, 'flag': '1'});
          },
          // 初始化表单结构
          async initFormStructure () {
              let formInfo = this.formInfo.formObj.structure[0];
              if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                  resetCascadeFieldVisible(formInfo.fieldsList, this.formData[0].values);
                  this.loadTimerField = new Date().getTime();
                  let initUserArr = [];
                  for (var i = 0; i < formInfo.fieldsList.length; i++) {
                      let tempField = formInfo.fieldsList[i];
                      let tempRefName = 'fieldItemChild' + i;
                      if (tempField && (tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                          setTimeout(() => {
                              // 设置下拉字段级联默认显示数据
                              if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                  this.$refs[tempRefName][0].initDefaultCasData();
                              }
                          }, 0);
                      }
                      if (tempField && !this.defaultViewOrder && tempField.type === 'subform') { // 用来显示默认第一个子表单
                          this.defaultViewOrder = i + '';
                          this.isViewSubFormViewBtn = true;// 显示子表单模式切换按钮
                      }
                      if (tempField && tempField.type === 'user') {
                          initUserArr.push(tempRefName);
                      }
                      if (tempField && tempField.type === 'date') {
                          setTimeout(() => {
                              // 设置下拉字段级联默认显示数据
                              if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                  this.$refs[tempRefName][0].upDynamicDateField();
                              }
                          }, 0);
                      }
                  }
                  for (var j = 0; j < initUserArr.length; j++) { // 针对人员级联初始化
                      let tempRefName = initUserArr[j];
                      setTimeout(async () => {
                          // 设置下拉字段级联默认显示数据
                          if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                              await this.$refs[tempRefName][0].setUserExtCascadeData(true);
                          }
                      }, 0);
                  }
              }
          },
          async _initData () {
              this.forms.forEach(element => {
                  let fieldsList = element.fieldsList;
                  let values = {};
                  let attributes = {};
                  for (let index = 0, len = fieldsList.length; index < len; index++) {
                      const element = fieldsList[index];
                      values[element.id] = '';
                      attributes[element.id] = element.type;
                      // 处理权限字段
                      let ext2 = element.options.ext2;
                      if (ext2) {
                          let curObj = JSON.parse(ext2);
                          element.formFieldAuth = curObj.formFieldAuth;
                          element.approveFieldAuth = curObj.approveFieldAuth;
                      }
                  }
                  this.collapseActiveName = element.id;
                  this.formData.push({
                      formId: element.id,
                      values: values,
                      attributes: attributes,
                      colSpan: element.colSpan ? element.colSpan : 1,
                      ext1: element.ext1 ? Number(element.ext1) : 0
                  });
              });
          },
          async handleShowFormDataUpdRecordList () {
              //   this.loadTimer = new Date().getTime();
              //   this.currentModeInstanceId = this.currentRowData.id;
              //   this.isShowFormDataUpdRecordListDialog = true;
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              this.searchParams.modelInstanceId = this.currentRowData.id;
              let formData = await getFormDataUpdRecordBOList(Object.assign({}, {
                  currentPage: 1,
                  pageSize: 100
              }, this.searchParams));
              if (formData && formData.data) {
                  this.rightActive = 2;
                  this.updRecordList = formData.data;
              } else {
                  this.$message.info('未查询到修改记录');
              }
              loading.close();
          },
          handleShowApprovalRecordList (index) {
              this.loadTimer = new Date().getTime();
              this.currentModeInstanceId = this.currentRowData.id;
              this.isShowApprovalRecordListDialog = true;
          },
          handlePrint (index) {
              index = index || 0;
              this.loadTimer = new Date().getTime();
              this.printForm = this.formData[index];
              this.printForm.fieldsList = this.forms[index].fieldsList;
              this.printForm.formName = this.forms[index].formName;
              this.printForm.printTemplate = this.forms[index].printTemplate;
              // if (!isEmpty(this.printForm.printTemplate)) {
              //   this.printForm.approvalRecordList = this.formInfo.formObj.approvalRecordList;
              if (this.approvalDetail.approVoList && this.approvalDetail.approVoList.length > 0) {
                  this.printForm.approvalRecordList = this.approvalDetail.approVoList;
              }
              this.printForm.applyUserName = this.formInfo.formObj.applyUserName;
              this.printForm.applyUserDept = this.formInfo.formObj.applyUserDept;
              this.printForm.applyUserCreated = this.formInfo.formObj.applyUserCreated;
              this.printForm.approvalStatus = this.formInfo.formObj.approvalStatus;
              // }
              this.dealPrintStr();
              this.isShowPrintUtil = true;
          },
          // 打印模板拼装
          dealPrintStr () {
              if (!isEmpty(this.printForm.printTemplate)) {
                  // 1、子表单占位符处理
                  this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('\r', '').replaceAll('\n', '');
                  // console.log(this.printForm.values);
                  // 获取打印模板中的子表单字段
                  // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                  let elementReg = /(?<={).*?(?=(}|$))/ig;
                  let elements = this.printForm.printTemplate.match(elementReg);
                  let fieldsList = this.printForm.fieldsList;
                  let subElements = [];
                  elements.forEach(item => {
                      for (let index = 0, len = fieldsList.length; index < len; index++) {
                          let fieldObj = fieldsList[index];
                          if (fieldObj.id === item) {
                              let type = fieldObj.type;
                              if (type === 'subform') {
                                  subElements.push(fieldObj);
                              }
                              break;
                          }
                      }
                  });
                  // 子表单字段数据替换、拼接
                  if (subElements.length > 0) {
                      let sourceData = this.printForm.values;
                      // 提取以@Sub开头,以Sub@结尾的中间部分字符串的正则表达式
                      let subFormStrReg = /(?<=@Sub).*?(?=(Sub@|$))/ig;
                      let subFormStrArr = this.printForm.printTemplate.match(subFormStrReg); // 子表单打印模板字符串list
                      for (let i = 0; i < subElements.length; i++) {
                          let subFormField = subElements[i];
                          // 替换子表单名
                          this.printForm.printTemplate = this.printForm.printTemplate.replace('{' + subFormField.id + '}', subFormField.name);
                          // 子表单打印模板
                          // <tr height="60px"><td>{11fd5298335a4cd18b125b689a99f552}</td><td>{a79bf19398024a2b985e7e452829eb7b}</td><td>{435c5c6efd684ca08eaa9d3910a0070f}</td><td>{4d3d281931bc40f8a14523ece5946723}人民币(大写):{d2557de3cd724c4097bfcca37a256510}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td><td>{03f90ff6cbc84997a50f3e849d404a15}</td></tr>
                          let subFormTr = clone(subFormStrArr[i]);
                          // 子表单打印模板中的字段占位符
                          let subFormElements = subFormTr.match(elementReg);
                          // console.log(subFormTr);
                          // 子表单数据list
                          let subFormData = sourceData[subFormField.id];
                          // console.log(subFormData);

                          // 替换后的子表单打印模板数据
                          let subFormDataPrint = [];
                          if (subFormData && subFormData.length > 0) {
                              subFormData.forEach(subFormDataItemStr => {
                                  let subFormTrItem = clone(subFormTr);
                                  let subFieldsList = subFormField.options.fieldList;// 子表单的所有字段
                                  subFormElements.forEach(item => {
                                      let sourceValue = ''; // 从源数据中拉出来的字段值
                                      let sourceContent = '{' + item + '}'; // 占位符
                                      for (let index = 0, len = subFieldsList.length; index < len; index++) {
                                          let fieldObj = subFieldsList[index];
                                          if (fieldObj.id === item) {
                                              let type = fieldObj.type;
                                              if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                                  // -tree
                                                  sourceValue = subFormDataItemStr[fieldObj.id + '-tree'];
                                              } else if (type === 'user') {
                                                  // -user
                                                  sourceValue = subFormDataItemStr[fieldObj.id + '-user'];
                                              } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                                  // -view
                                                  sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                              } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                                  sourceValue = subFormDataItemStr[fieldObj.id];
                                              } else if (type === 'link') {
                                                  sourceValue = subFormDataItemStr[fieldObj.id + '-view'];
                                              }
                                              break;
                                          }
                                      }
                                      if (sourceValue === undefined) {
                                          sourceValue = '';
                                      }
                                      subFormTrItem = subFormTrItem.replaceAll(sourceContent, sourceValue);
                                  });
                                  subFormDataPrint.push(subFormTrItem);
                              });
                          }
                          // 替换后的最终的子表单数据
                          let subFormDataPrintStr = '';
                          for (let index = 0; index < subFormDataPrint.length; index++) {
                              subFormDataPrintStr = subFormDataPrintStr + subFormDataPrint[index];
                          }
                          // 替换到总打印模板里
                          this.printForm.printTemplate = this.printForm.printTemplate.replaceAll('@Sub' + subFormTr + 'Sub@', subFormDataPrintStr);
                          // console.log(this.printForm.printTemplate);
                      }
                  }

                  // 2、表单字段占位符替换处理
                  // console.log(this.printForm.values);
                  // 提取以{开头,以}结尾的中间部分字符串的正则表达式：(?<={).*?(?=(}|$))/ig
                  // let elementReg = /(?<={).*?(?=(}|$))/ig;
                  // let elements = this.printForm.printTemplate.match(elementReg);
                  // console.log(elements);
                  if (!isEmpty(elements)) {
                      let sourceData = this.printForm.values;
                      let fieldsList = this.printForm.fieldsList;
                      elements.forEach(item => {
                          let sourceValue = ''; // 从源数据中拉出来的字段值
                          let sourceContent = '{' + item + '}'; // 占位符
                          for (let index = 0, len = fieldsList.length; index < len; index++) {
                              let fieldObj = fieldsList[index];
                              if (fieldObj.id === item) {
                                  let type = fieldObj.type;
                                  if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                                      // -tree
                                      sourceValue = sourceData[fieldObj.id + '-tree'];
                                  } else if (type === 'user') {
                                      // -user
                                      sourceValue = sourceData[fieldObj.id + '-user'];
                                  } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                                      // -view
                                      sourceValue = sourceData[fieldObj.id + '-view'];
                                  } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date' || type === 'subFormSummary') {
                                      sourceValue = sourceData[fieldObj.id];
                                  } else if (type === 'link') {
                                      sourceValue = sourceData[fieldObj.id + '-view'];
                                  } else if (type === 'subform') {
                                      sourceValue = sourceData[fieldObj.id];
                                  }
                                  break;
                              }
                          }
                          if (sourceValue === undefined) {
                              sourceValue = '';
                          }
                          this.printForm.printTemplate = this.printForm.printTemplate.replaceAll(sourceContent, sourceValue);
                      });
                  }
              }
          },
          handlePrintApprove (index) {
              this.loadTimer = new Date().getTime();
              this.printForm = this.formData[index];
              this.printForm.fieldsList = this.forms[index].fieldsList;
              this.printForm.formName = this.forms[index].formName;
              this.printForm.approvalRecordList = this.formInfo.formObj.approvalRecordList;
              this.printForm.applyUserName = this.formInfo.formObj.applyUserName;
              this.printForm.applyUserDept = this.formInfo.formObj.applyUserDept;
              this.printForm.applyUserCreated = this.formInfo.formObj.applyUserCreated;
              this.printForm.approvalStatus = this.formInfo.formObj.approvalStatus;
              this.isShowApproval = true;
          },
          async handleStartApproval (index) {
              let values = this.formData[index].values;
              if (values['26689e30b998426a85679c247bbe44f3'] !== 'C4AE131C' && values['26689e30b998426a85679c247bbe44f3'] !== 'E5F31105') {
                  let durlist = await getModelFormInstanceApprovalDurList({'formId': this.formData[index].formId, 'flag': '2'});
                  // console.log(durlist);
                  if (durlist && durlist.length > 0) {
                      this.$message({message: '尚有逾期未还款的借款记录，不能发起审批！', type: 'warning', duration: 1500});
                      return;
                  }
              }
              if (this.formData[index].formId === '613087a8672244aca9758ffa766635cc') {
                  let flg = false;
                  this.$refs['customForm' + index][0].validate((valid) => {
                      if (valid) {
                          flg = true;
                      } else {
                          flg = false;
                      }
                  });
                  if (flg) {
                      this.loadTimer = new Date().getTime();
                      this.approvalForm = this.formData[index];
                      if (this.currentRowData) {
                          this.approvalForm.dataId = this.currentRowData.id;
                      } else {
                          this.approvalForm.dataId = '';
                      }
                      // console.log('000000000');
                      this.$emit('clearTimeOut');
                      this.isShowApprovalTemplatePop = true;
                  } else {
                      this.$message({message: '表单数据校验不通过，请修改信息!', type: 'warning', duration: 1500});
                  }
              } else {
                  this.loadTimer = new Date().getTime();
                  this.approvalForm = this.formData[index];
                  if (this.currentRowData) {
                      this.approvalForm.dataId = this.currentRowData.id;
                  } else {
                      this.approvalForm.dataId = '';
                  }
                  // console.log('000000000');
                  this.$emit('clearTimeOut');
                  this.isShowApprovalTemplatePop = true;
              }
          },
          /** 自定义表单的配置信息，动态生产表单双向绑定所需的数据结构 */
          async _initFormData () {
              let objModelFormData = await this._getModelFormData();
              this.formData = [];
              this.$emit('setIsShowForm', false);
              this.isShowSaveBtn = false;
              if (objModelFormData) {
                  this.collapseActiveName = objModelFormData.formId;
                  let attributes = this.getAttributes(this.formInfo.formObj.structure);// 初始化数据字段结构
                  objModelFormData.attributes = attributes;
                  //= =========解决新增多选组件，历史数据无法使用该组件的问题begin===========
                  let values = clone(objModelFormData.values);
                  for (var prop in attributes) { // 遍历map
                      if (attributes.hasOwnProperty(prop)) {
                          if (attributes[prop] === 'category' || attributes[prop] === 'serialNumber' || attributes[prop] === 'subform') {
                              if (!values.hasOwnProperty(prop)) {
                                  values[prop] = '';
                              }
                          }
                          if (attributes[prop] === 'subform' && values[prop] && values[prop].length > 0) {
                              values[prop].forEach(v => {
                                  if (!v.subId) {
                                      v.subId = getUUID(8, 16);
                                  }
                              });
                          }
                      }
                  }
                  objModelFormData.values = values;
                  // 解决导入的数据，选项级联显示字段不显示的问题
                  this.$nextTick(() => {
                      this.initFormStructure();
                  });
                  //= =========解决新增多选组件，历史数据无法使用该组件的问题end===============
                  this.formData.push(objModelFormData);
                  this.isShowSaveBtn = true;
              } else {
                  await this._initData();
              }
              this.$emit('setIsShowForm', true);
          },
          async loadFormData (formInfo, formBtnAuth, row, isShowDown) {
              if (row) {
                  this.id = row.id;
              } else if (this.formInfo.currentDataId) {
                  this.id = this.formInfo.currentDataId;
              }
              this.isManageMode = formInfo.isManageMode;
              this.formInfo = formInfo;
              this.isShowStartApprovalBtn = this.formInfo.formObj.canStartApproval;
              this.formBtnAuth = formBtnAuth;
              await this._initFormData();
              if (row === undefined && !this.isRead) {
                  this.currentRowData = {id: '', approvalInstanceId: ''};
                  this.isAddForm = true;
              } else {
                  if (row.approvalInstanceId) {
                      let param = {instanceId: row.id, approvalInstanceId: row.approvalInstanceId, formId: formInfo.formId};
                      let res = await getModeInstanceProcessDetail(param);
                      row.businessInstanceId = res.businessInstanceId;
                      row.businessInstanceName = res.businessInstanceName;
                      this.formInfo.approvalInstanceId = res.approvalInstanceId;
                      this.formInfo.businessInstanceId = res.businessInstanceId;
                      this.formInfo.businessInstanceName = res.businessInstanceName;
                      this.formInfo.formObj.applyUserName = res.applyUserName;
                      this.formInfo.formObj.applyUserDept = res.applyUserDept;
                      this.formInfo.formObj.applyUserCreated = res.applyUserCreated;
                      this.formInfo.formObj.approvalStatus = res.approvalStatus;
                      this.formInfo.formObj.approvalRecordList = res.approvalRecordList;
                  }
                  this.currentRowData = row;
              }
              this.isShowSaveBtn = true;
              this.isShowDown = isShowDown;

              // TODO
              this.loadTimerRelate = new Date().getTime();
              this.getModelListByMainFormId();
              // 获取审批详情
              if (!this.isAddForm) {
                  this.handleApprovalDetail();
              }
          },
          getAttributes (source) {
              let attributes = {};
              source.forEach(element => {
                  let fieldsList = element.fieldsList;
                  for (let index = 0, len = fieldsList.length; index < len; index++) {
                      const element = fieldsList[index];
                      attributes[element.id] = element.type;
                  }
              });
              return attributes;
          },
          dkqrRequiredRuleSetting () { // 中兴华咨到款确认单个性化必填规则  edit by hezhen 2024-04-16
              let fData = this.formData[0];
              if (fData) {
                  // 根据【到款所属】字段选择：总部 3BA41102    分公司  E396B234
                  let dkss = fData.values['b62938e3de1a4fccb945e68de0959617'];
                  if (dkss === '3BA41102') { // 1.总部   ->  收款公示 必填，  发票 不必填
                      // this.$refs['customForm0'][0].clearValidate('b21967a4cc74493496c84351c86570d7');// 发票
                      let skgg = fData.values['729df5c59e1847828c93e5a2e042fd03'];// 收款公示
                      if (!skgg) {
                          this.$message({message: '【关联预收公示】是必填项，请填写信息!', type: 'warning', duration: 1500});
                          return true;
                      }
                  } else if (dkss === 'E396B234') { // 2.分公司 ->  收款公示 不必填  发票必填
                      let dklx = fData.values['8d7d2124abd34e84a016141bdbc3bcc6']; // 到款类型 已立项到款 9245D31D
                      if (dklx === '9245D31D') { // 只有已立项到款才进行发票单的必填项约束 20240710
                      // this.$refs['customForm0'][0].clearValidate('729df5c59e1847828c93e5a2e042fd03');// 收款公示
                          let fp = fData.values['b21967a4cc74493496c84351c86570d7'];// 发票
                          if (!fp) {
                              this.$message({message: '【关联发票单】是必填项，请填写信息!', type: 'warning', duration: 1500});
                              return true;
                          }
                      }
                  }
              }
              return false;
          },

          handleModelComplete () {
              if (this.dkqrRequiredRuleSetting()) {
                  return;
              }
              // 1.判断是否是用户表扩展字段，是的话需要先查询数据库校验数据
              this.$refs['customForm0'][0].validate(async (valid) => {
                  if (valid || this.formInfo.formObj.dataBefor) {
                      const loading = this.$loading({
                          lock: true,
                          text: 'Loading',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                      });
                      try {
                          // 流水号保存生成字段渲染
                          let formInfo = this.formInfo.formObj.structure[0];
                          let fData = this.formData[0];
                          let formRequireFieldList = {};
                          if (!fData.values.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                              let requireArray = [];
                              for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                  let field = formInfo.fieldsList[fieldIndex];
                                  if (field.type === 'subform' && fData.values[field.formField] && fData.values[field.formField].length > 0) {
                                      for (var dataIndex = 0; dataIndex < fData.values[field.formField].length; dataIndex++) {
                                          for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                              let subField = field.options.fieldList[subFieldIndex];
                                              if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && subField.options.config.options.length > 0 && !fData.values[field.formField][dataIndex][subField.formField]) {
                                                  await this.setSerialNumber(subField.options.config.options[0].value, subField, fData.values[field.formField][dataIndex], formInfo);
                                              } else if (subField.type === 'serialNumber' && subField.options.ext3 === '6') { // 根据字段值进行生成流水号
                                                  let ext2Obj = JSON.parse(subField.options.ext2);
                                                  let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                                  if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                      await this.setSerialNumber(subField.options.config.options[0].value, subField, fData.values[field.formField][dataIndex], formInfo);
                                                  }
                                              }
                                          }
                                      }
                                  } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                      await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                  } else if (field.type === 'serialNumber' && field.options.ext3 === '6') {
                                      let ext2Obj = JSON.parse(field.options.ext2);
                                      let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                      if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                          for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                              if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                  await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                              }
                                          }
                                      } else {
                                          if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                              await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                          }
                                      }
                                  } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                      let ext2 = field.options.ext2;
                                      if (ext2) {
                                          let ext2Obj = JSON.parse(ext2);
                                          if (ext2Obj.moreSerialNumber) { // 多规则配置
                                              let seriaNumberAutoincrementType = null;
                                              let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                              for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                  let element = serialNumberRuleList[i];
                                                  let takeEffectField = element.takeEffectField;
                                                  let takeEffectFieldValue = element.takeEffectFieldValue;
                                                  let formFieldVal = fData.values[takeEffectField];
                                                  if (element.seriaNumberAutoincrementType) { // 说明配置了自增体 1部门自增体 流水号自增体
                                                      seriaNumberAutoincrementType = element.seriaNumberAutoincrementType;
                                                  }
                                                  if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                      if (element.seriaNumberDepartTypeFormFieldId) {
                                                          ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                      }
                                                      if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                          ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                      }
                                                      if (element.seriaNumberSelectTypeFormFieldId) {
                                                          ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                      }
                                                      field.options.ext2 = JSON.stringify(ext2Obj);
                                                      await this.setSerialNumber(element.selectedNode.id, field, fData.values, formInfo, seriaNumberAutoincrementType);
                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                  }
                                  if (field.type === 'subform' && field.isView && isFormFieldVisible(field, fData.values)) {
                                      if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                          this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      } else { // 子表单有值，需要验证子表单内的必填项
                                          let subFlag = false;
                                          let sonFieldList = field.options.fieldList;
                                          let fieldNames = [];
                                          for (let i = 0; i < sonFieldList.length; i++) {
                                              let cur = sonFieldList[i];
                                              if (cur.options.required) { // 有必填项
                                                  for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                      let curObj = fData.values[field.formField][i];
                                                      if (!isFormFieldVisible(cur, curObj)) {
                                                          continue;
                                                      }
                                                      let curValue = curObj[cur.id];
                                                      if (!curValue) { // 有值
                                                          subFlag = true;
                                                          fieldNames.push(cur.label);
                                                          break;
                                                      }
                                                  }
                                              }
                                          }
                                          if (subFlag) {
                                              this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                              return;
                                          }
                                      }
                                  }
                                  if (field.type === 'file' && field.isView && isFormFieldVisible(field, fData.values)) {
                                      if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                          this.verifySpecialField(field.id);
                                          this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                                  if (field.type === 'archive' && field.isView && isFormFieldVisible(field, fData.values)) {
                                      if (field.options.required && field.options.config.type === 'multi' && !fData.values[field.formField + '-archiveId']) {
                                          this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                                  if (field.type === 'text') {
                                      if (field.options.upMoneyField) { // 配置了金额大写
                                          let upMoneyId = field.options.upMoneyField;
                                          let res = this.convertCurrency(fData.values[upMoneyId]);
                                          fData.values[field.id] = res;
                                      } else if (field.options.ext1) { // 超链接字段
                                          if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                              this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                              return;
                                          }
                                      }
                                  }
                                  if (isRequiredFormFieldVisible(field, fData.values)) { // 当前字段是必填项
                                      requireArray.push(field.id);
                                  }
                              }
                              let formId = formInfo.id;
                              if (formId) {
                                  formRequireFieldList[formId] = requireArray;
                                  fData['requireFieldArray'] = requireArray;
                              }
                          }
                          // console.log(this.tempFormData);
                          // console.log(this.relateModelList);
                          // 关联子表的必填校验
                          if (this.isAddForm) {
                              if (formInfo.relateModelRequired && this.showRelateFormTab && (this.relateModelList && this.relateModelList.length > 0)) {
                                  if (formInfo.id === '727d0cd345484dda86a130f566d61081') { // 中泽的合同信息表
                                      // console.log(this.formData[0]);
                                      // 获取合同类型的值
                                      let itemValue = this.formData[0].values['8661037efcce49048b8e5d8c13356ef6'];
                                      // 项目合同DEE500FA、业务结算合同97CDC0E0
                                      if (itemValue === 'DEE500FA' || itemValue === '97CDC0E0') {
                                          if (this.tempFormData.length === 0) {
                                              this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!1', type: 'warning', duration: 3000});
                                              return;
                                          } else { // 多个关联子表，每个子表都需要校验是否有值了
                                              //   console.log('ddd');
                                              for (let k = 0; k < this.relateModelList.length; k++) {
                                                  let relateModel = this.relateModelList[k];
                                                  for (let j = 0; j < this.tempFormData.length; j++) {
                                                      let relateFormData = this.tempFormData[j];
                                                      if (relateFormData.formId === relateModel.formId) {
                                                          relateModel.hasData = true;
                                                          break;
                                                      }
                                                  }
                                                  if (relateModel.hasData) {
                                                      continue;
                                                  } else {
                                                      this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                                      return;
                                                  }
                                              }
                                          }
                                      }
                                  } else {
                                      if (this.tempFormData.length === 0) {
                                          this.$message({message: '关联子表是必填项，尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                          return;
                                      } else { // 多个关联子表，每个子表都需要校验是否有值了
                                          for (let k = 0; k < this.relateModelList.length; k++) {
                                              let relateModel = this.relateModelList[k];
                                              for (let j = 0; j < this.tempFormData.length; j++) {
                                                  let relateFormData = this.tempFormData[j];
                                                  if (relateFormData.formId === relateModel.formId) {
                                                      relateModel.hasData = true;
                                                      break;
                                                  }
                                              }
                                              if (relateModel.hasData) {
                                                  continue;
                                              } else {
                                                  this.$message({message: '关联子表【' + relateModel.modelName + '】尚未填写数据，请填写后再保存!', type: 'warning', duration: 3000});
                                                  return;
                                              }
                                          }
                                      }
                                  }
                              }
                          }
                          // 检查数字类型校验
                          let resObj = await this.$refs.fieldValidation.validateNumberRule(formInfo.fieldsList, fData.values, this.tempFormData);
                          if (resObj.isRefuse) {
                              let tempRefName = resObj.tempRefName;
                              let tempRefKey = resObj.tempRefKey;
                              if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                  if (this.$refs[tempRefName][0]) {
                                      this.$refs[tempRefName][0].fieldFocus(tempRefKey);
                                  }
                              }
                              this.$message({message: '表单字段校验失败!' + resObj.refuseInfo, type: 'warning', duration: 3000});
                              return;
                          }
                          // 校验子表单必填项
                          for (let fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                              let field = formInfo.fieldsList[fieldIndex];
                              if (field.type === 'subform' && field.isView && isFormFieldVisible(field, fData.values)) {
                                  if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                      this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                      return;
                                  } else { // 子表单有值，需要验证子表单内的必填项
                                      let subFlag = false;
                                      let sonFieldList = field.options.fieldList;
                                      let fieldNames = [];
                                      for (let i = 0; i < sonFieldList.length; i++) {
                                          let cur = sonFieldList[i];
                                          if (cur.options.required) { // 有必填项
                                              for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                  let curObj = fData.values[field.formField][i];
                                                  if (!isFormFieldVisible(cur, curObj)) {
                                                      continue;
                                                  }
                                                  let curValue = curObj[cur.id];
                                                  if (!curValue) { // 有值
                                                      subFlag = true;
                                                      fieldNames.push(cur.label);
                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                      if (subFlag) {
                                          this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                              }
                          }
                          await this.dealSelRuleSetting(formInfo.fieldsList, fData.values);
                          setTimeout(() => {
                              this.$emit('modelComplete', {
                                  forms: this.formData,
                                  modelId: formInfo.modelId,
                                  tempFormData: this.tempFormData
                              });
                          }, 300);
                      } catch (error) {
                          loading.close();
                          console.error('保存表单数据异常：', error);
                      } finally {
                          loading.close();
                      }
                  } else {
                      let formInfo = this.formInfo.formObj.structure[0];
                      let fData = this.formData[0];
                      let values = fData.values;
                      if (!fData.values.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                          for (let fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                              let field = formInfo.fieldsList[fieldIndex];
                              if (isRequiredFormFieldVisible(field, values) && (field.type === 'file' || field.type === 'category' || field.type === 'link')) {
                                  if (values[field.id] === '') {
                                      this.verifySpecialField(field.id);
                                      this.$message.error(field.name + '不能为空');
                                      return;
                                  }
                              } else if (field.type === 'subform' && field.isView && isFormFieldVisible(field, fData.values)) {
                                  if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                      this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                      return;
                                  } else { // 子表单有值，需要验证子表单内的必填项
                                      let subFlag = false;
                                      let sonFieldList = field.options.fieldList;
                                      let fieldNames = [];
                                      for (let i = 0; i < sonFieldList.length; i++) {
                                          let cur = sonFieldList[i];
                                          if (cur.options.required) { // 有必填项
                                              for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                  let curObj = fData.values[field.formField][i];
                                                  if (!isFormFieldVisible(cur, curObj)) {
                                                      continue;
                                                  }
                                                  let curValue = curObj[cur.id];
                                                  if (!curValue) { // 有值
                                                      subFlag = true;
                                                      fieldNames.push(cur.label);
                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                      if (subFlag) {
                                          this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                              } else if (field.type === 'archive' && field.isView && isFormFieldVisible(field, fData.values)) {
                                  if (field.options.required && field.options.config.type === 'multi' && !values[field.id + '-archiveId']) {
                                      this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                      return;
                                  }
                              } else if (field.type === 'text' && isFormFieldVisible(field, values)) {
                                  if (field.options.ext1) { // 超链接字段
                                      if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                          this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                              }
                          }
                      } else {
                          for (let fieldIndex = 0; fieldIndex < this.formInfo.formObj.structure[0].fieldsList.length; fieldIndex++) {
                              let field = this.formInfo.formObj.structure[0].fieldsList[fieldIndex];
                              if (isRequiredFormFieldVisible(field, values) && (field.type === 'file' || field.type === 'category' || field.type === 'link')) {
                                  if (!values[field.id] || values[field.id] === '') {
                                      this.verifySpecialField(field.id);
                                      this.$message.error(field.name + '不能为空');
                                      return;
                                  }
                              } else if (field.type === 'subform' && field.isView && isFormFieldVisible(field, fData.values)) {
                                  if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                      this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                      return;
                                  } else { // 子表单有值，需要验证子表单内的必填项
                                      let subFlag = false;
                                      let sonFieldList = field.options.fieldList;
                                      let fieldNames = [];
                                      for (let i = 0; i < sonFieldList.length; i++) {
                                          let cur = sonFieldList[i];
                                          if (cur.options.required) { // 有必填项
                                              for (let i = 0; i < fData.values[field.formField].length; i++) {
                                                  let curObj = fData.values[field.formField][i];
                                                  if (!isFormFieldVisible(cur, curObj)) {
                                                      continue;
                                                  }
                                                  let curValue = curObj[cur.id];
                                                  if (!curValue) { // 有值
                                                      subFlag = true;
                                                      fieldNames.push(cur.label);
                                                      break;
                                                  }
                                              }
                                          }
                                      }
                                      if (subFlag) {
                                          this.$message({message: field.name + '中的' + fieldNames.join(',') + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                              } else if (field.type === 'archive' && field.isView && isFormFieldVisible(field, fData.values)) {
                                  if (field.options.required && field.options.config.type === 'multi' && !values[field.id + '-archiveId']) {
                                      this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                      return;
                                  }
                              } else if (field.type === 'text' && isFormFieldVisible(field, values)) {
                                  if (field.options.ext1) { // 超链接字段
                                      if (isRequiredFormFieldVisible(field, fData.values) && fData.values[field.formField].length < 1) {
                                          this.$message({message: field.name + '是必填项，请填写信息!', type: 'warning', duration: 1500});
                                          return;
                                      }
                                  }
                              }
                          }
                      }
                      return false;
                  }
              });
          },
          async dealSelRuleSetting (fieldsList, formValues) { // 根据表单数据规则设置设置下拉或选项类型字段的选中值
              let fieldsMap = new Map();
              let fieldRuleMap = new Map();// 字段规则map
              let fieldSelKVMap = new Map();
              if (fieldsList && Array.isArray(fieldsList)) {
                  for (var index = 0; index < fieldsList.length; index++) {
                      let field = fieldsList[index];
                      fieldsMap.set(field.id, field);
                      if (field.type === 'select' || (field.type === 'category' && field.options.config.type === 'single')) {
                          for (let k = 0; k < field.options.config.options.length; k++) {
                              let item = field.options.config.options[k];
                              if (isEmpty(item.assignmentFieldId) && !isEmpty(item.assignmentFieldValue)) { // key为空，值不为空
                                  fieldRuleMap.set(item.value, item.assignmentFieldValue);
                                  fieldSelKVMap.set(item.value, field.id);
                              }
                          }
                      }
                  }
              }
              if (fieldRuleMap.size > 0) {
                  // console.log(fieldRuleMap);
                  // console.log(fieldSelKVMap);
                  let tansgerFieldRuleMap = new Map();// 字段规则map
                  for (let fieldIndex = 0; fieldIndex < fieldsList.length; fieldIndex++) {
                      let field = fieldsList[fieldIndex];
                      fieldRuleMap.forEach(function (value, key) {
                          if (value && value.indexOf(field.name) !== -1) {
                              let tempVal = '';
                              if (tansgerFieldRuleMap.has(key)) {
                                  tempVal = tansgerFieldRuleMap.get(key);
                                  tempVal = tempVal.replace(field.name, field.id);
                              } else {
                                  tempVal = value.replace(field.name, field.id);
                              }
                              tansgerFieldRuleMap.set(key, tempVal);
                          }
                      });
                  }
                  // console.log(tansgerFieldRuleMap);
                  let finalArr = [];
                  tansgerFieldRuleMap.forEach(function (value, key) {
                      finalArr.push({key: key, value: value});
                  });
                  // console.log(finalArr);
                  for (let i = 0; i < finalArr.length; i++) {
                      let obj = finalArr[i];
                      let result = await this.$refs.fieldValidation.chkPassRule(null, obj.value.trim(), formValues, fieldsMap, null);
                      // console.log(result);
                      if (result) {
                          formValues[fieldSelKVMap.get(obj.key)] = obj.key;
                      }
                  }
                  // console.log(formValues);
              }
          },
          convertCurrency (money) {
              // 汉字的数字
              // eslint-disable-next-line no-array-constructor
              var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
              // 基本单位
              // eslint-disable-next-line no-array-constructor
              var cnIntRadice = new Array('', '拾', '佰', '仟');
              // 对应整数部分扩展单位
              // eslint-disable-next-line no-array-constructor
              var cnIntUnits = new Array('', '万', '亿', '兆');
              // 对应小数部分单位
              // eslint-disable-next-line no-array-constructor
              var cnDecUnits = new Array('角', '分', '毫', '厘');
              // 整数金额时后面跟的字符
              var cnInteger = '整';
              // 整型完以后的单位
              var cnIntLast = '元';
              // 最大处理的数字
              var maxNum = 999999999999999.9999;
              // 金额整数部分
              var integerNum;
              // 金额小数部分
              var decimalNum;
              // 输出的中文金额字符串
              var chineseStr = '';
              // 分离金额后用的数组，预定义
              var parts;
              if (money == '') { return ''; }
              money = parseFloat(money);
              if (money >= maxNum) {
              // 超出最大处理数字
                  return '';
              }
              if (money == 0) {
                  chineseStr = cnNums[0] + cnIntLast + cnInteger;
                  return chineseStr;
              }
              // 转换为字符串
              money = money.toString();
              if (money.indexOf('.') == -1) {
                  integerNum = money;
                  decimalNum = '';
              } else {
                  parts = money.split('.');
                  integerNum = parts[0];
                  decimalNum = parts[1].substr(0, 4);
              }
              // 获取整型部分转换
              if (parseInt(integerNum, 10) > 0) {
                  var zeroCount = 0;
                  var IntLen = integerNum.length;
                  for (var i = 0; i < IntLen; i++) {
                      var n = integerNum.substr(i, 1);
                      var p = IntLen - i - 1;
                      var q = p / 4;
                      var m = p % 4;
                      if (n == '0') {
                          zeroCount++;
                      } else {
                          if (zeroCount > 0) {
                              chineseStr += cnNums[0];
                          }
                          // 归零
                          zeroCount = 0;
                          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                      }
                      if (m == 0 && zeroCount < 4) {
                          chineseStr += cnIntUnits[q];
                      }
                  }
                  chineseStr += cnIntLast;
              }
              // 小数部分
              if (decimalNum != '') {
                  var decLen = decimalNum.length;
                  for (var i = 0; i < decLen; i++) {
                      var n = decimalNum.substr(i, 1);
                      if (n != '0') {
                          chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                      }
                  }
              }
              if (chineseStr == '') {
                  chineseStr += cnNums[0] + cnIntLast + cnInteger;
              } else if (decimalNum == '') {
                  chineseStr += cnInteger;
              }
              return chineseStr;
          },
          async setSerialNumber (sid, field, formData, formInfo, seriaNumberAutoincrementType) {
              if (sid) {
                  let busiId = null;
                  let departId = null;
                  let configOptionId = null;
                  let upSerialNumber = null; // 国融合同表单框架合同号
                  for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                      let tempField = formInfo.fieldsList[fieldIndex];
                      if (tempField.type === 'businessTree') {
                          busiId = formData[tempField.formField];
                      } else if (tempField.type === 'department') {
                          departId = formData[tempField.formField];
                      } else if (tempField.type === 'select') {
                          // 中泽的项目立项表的业务分类选项字段
                          if (tempField.id === '1d3bb7fd093943709bfbd36fd6c15ca4') {
                              let optionValue = formData[tempField.formField];
                              let configOptions = tempField.options.config.options;
                              for (let k = 0; k < configOptions.length; k++) {
                                  let item = configOptions[k];
                                  if (item.value === optionValue) {
                                      configOptionId = item.id;
                                      break;
                                  }
                              }
                          }
                      } else if (tempField.type === 'link') {
                          if (formInfo.id === 'b81cbd9fa972415ebb00d3e40e1f5522') { // 国融【合同信息表】
                              if (tempField.id === '7abddcef62424e4b99145cfa7080e42c') { // 合同表单的【关联框架合同】字段
                                  let linkObj = formData[tempField.formField];
                                  // console.log(linkObj);
                                  if (linkObj) {
                                      let linkObjTableData = linkObj['tableData'][0];
                                      if (linkObjTableData) {
                                          // 合同编号 c6219b4ce1e94150b0f0a00ab63ecf83
                                          upSerialNumber = linkObjTableData['c6219b4ce1e94150b0f0a00ab63ecf83'];
                                          // console.log(upSerialNumber);
                                      }
                                  }
                              }
                          }
                      }
                  }
                  let numberObj = null;
                  let departmentId = null;
                  if (field.options.ext2) {
                      let ext2Obj = JSON.parse(field.options.ext2);
                      if (ext2Obj.seriaNumberFormFieldId) { // 部门占位符取值
                          departmentId = formData[ext2Obj.seriaNumberFormFieldId];
                          if (departmentId) {
                              departmentId = Number(departmentId);
                              let param = {id: sid, busiId: busiId, departId: departId, departmentId: departmentId};
                              if (seriaNumberAutoincrementType) {
                                  param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                              }
                              numberObj = await getSerialNumberDepartment(param);
                          } else {
                              this.$message.error('流水号关联的部门未选取,数据无法生成流水号');
                              return;
                          }
                      } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId && ext2Obj.seriaNumberDepartTypeFormFieldId) { // 业务分类和部门都选择的
                          let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                          let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                          let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberBusinessTypeFormFieldId) { // 业务分类
                          let businessId = formData[ext2Obj.seriaNumberBusinessTypeFormFieldId];
                          let param = {id: sid, businessId: businessId, businessField: ext2Obj.seriaNumberBusinessTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberDepartTypeFormFieldId) { // 部门
                          let departId = formData[ext2Obj.seriaNumberDepartTypeFormFieldId];
                          let param = {id: sid, departId: departId, departField: ext2Obj.seriaNumberDepartTypeFormFieldIdValue};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                          let param = {id: sid};
                          if (ext2Obj.seriaNumberSelectTypeFormFieldId) {
                              let fieldVal = formData[ext2Obj.seriaNumberSelectTypeFormFieldId];
                              if (fieldVal) { // 下拉选项选值了
                                  let fieldObj = formInfo.fieldsList.find(element => element.id === ext2Obj.seriaNumberSelectTypeFormFieldId);
                                  let options = fieldObj.options.config.options;
                                  let optionsObj = options.find(element => element.value === fieldVal);
                                  //   if (optionsObj.serialNumberValue) {
                                  param.seriaNumberSelectTypeFormVal = optionsObj.serialNumberValue;
                                  param.seriaNumberSelectTypeFormFieldId = ext2Obj.seriaNumberSelectTypeFormFieldId;
                                  if (seriaNumberAutoincrementType) {
                                      param.seriaNumberAutoincrementType = seriaNumberAutoincrementType;
                                  }
                                  //   }
                              }
                          }
                          numberObj = await getSerialNumberPlus(param);
                      } else {
                          if (busiId && departId) {
                              numberObj = await getSerialNumber(sid, busiId, departId);
                          } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                              numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                          } else {
                              numberObj = await getSerialNumber(sid);
                          }
                      }
                  } else {
                      if (busiId && departId) {
                          numberObj = await getSerialNumber(sid, busiId, departId);
                      } else if (departId && configOptionId) { // 根据部门和选项值获取流水号
                          numberObj = await getSerialNumberDepAndOption(sid, departId, configOptionId);
                      } else {
                          numberObj = await getSerialNumber(sid);
                      }
                  }
                  if (numberObj) {
                      formData[field.formField] = numberObj.newSerialNumber;
                      formData[field.formField + '-sn'] = numberObj.sn;
                      if (upSerialNumber) {
                          formData[field.formField] = upSerialNumber + '-' + numberObj.newSerialNumber;
                      }
                      // console.log(formData[field.formField]);
                  }
              }
          },
          handleView () {
              this.$emit('handleView', this.currentRowData);
          },
          exportExcelData () {
              this.$emit('exportExcelData', this.currentRowData);
          },
          viewCardModel () {
              this.cardFormId = this.formInfo.formId;
              this.cardInstanceId = this.currentRowData.id;
              this.cardLoadTimer = new Date().getTime();
              this.isShowForms = true;
              // this.$message({
              //     message: '您无查看当前表单库权限，若想查看请联系管理员！',
              //     type: 'warning',
              //     duration: 3000
              // });
          },
          handleModelFormDelete () {
              this.$emit('handleModelFormDelete', this.currentRowData);
          },
          _getModelFormData () {
              let temporaryModelFormData;
              if (this.formInfo.formObj && this.formInfo.formObj.instance) {
                  try {
                      let strTemporaryData = this.formInfo.formObj.instance;
                      let objTemporaryData = JSON.parse(strTemporaryData);
                      temporaryModelFormData = objTemporaryData;
                  } catch (error) {
                      console.error('解析模型表单数据异常：', error);
                  }
              }
              return temporaryModelFormData;
          },
          switchAddFormData () {
              this.$emit('switchMode', 1);
          },
          dataExport () {
              let url = `${API_EXPORT_MODEL_TITLE_FORM_EXCEL}`;
              url = url.replace(':modelId', this.formInfo.formObj.structure[0].modelId);
              this.download(url);
          },
          download (url) {
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = url;
              document.body.appendChild(iframe);
          },
          handleNavPage () { // 审批流发起或保存成功返回处理逻辑
              if (this.isReturnToNav) { // 返回客户端方的方法进行页面跳转或逻辑操作
                  this.isShowApprovalTemplatePop = false;
                  this.$emit('handleNavPage');
              } else {
                  let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                  let currentUserInfo = JSON.parse(currentUserStr);
                  if (currentUserInfo.switchLayoutFlg === 2) {
                      this.navMyApprovalApplied();
                  } else {
                      this.navMyApproval();
                  }
              }
          },
          loadLinkData (data, targetField) {
              let formInfo = this.formInfo.formObj.structure[0];
              if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                  for (var i = 0; i < formInfo.fieldsList.length; i++) {
                      let tempField = formInfo.fieldsList[i];
                      if (targetField.id === tempField.id) {
                          this.$refs['fieldItemChild' + i][0].initAddLinkData(data);
                      }
                  }
              }
          },
          loadDeptField (treeRoot, targetField) {
              let formInfo = this.formInfo.formObj.structure[0];
              if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                  for (var i = 0; i < formInfo.fieldsList.length; i++) {
                      let tempField = formInfo.fieldsList[i];
                      if (targetField.id === tempField.id) {
                          this.$refs['fieldItemChild' + i][0].initDeptField(treeRoot);
                      }
                  }
              }
          },
          async asynMainFormData (sourceData, selectTableColumns, currentlinkFieldId, index) {
              if (selectTableColumns && Array.isArray(selectTableColumns)) {
                  let targetFormFieldlist = this.forms[0].fieldsList;
                  selectTableColumns.forEach(fieldObj => {
                      let sourceFieldLabel = fieldObj.label;
                      targetFormFieldlist.forEach(element => {
                          if (element.options.synLinkField && element.options.synLinkField === currentlinkFieldId) {
                              if (element.options.synLinkFormFieldId) {
                                  if (element.options.synLinkFormFieldId === fieldObj.id) {
                                      this.updSynLinkFieldData(element, fieldObj, sourceData);
                                  }
                              } else {
                                  if (sourceFieldLabel === element.name && element.type === 'text') {
                                      this.updSynLinkFieldData(element, fieldObj, sourceData);
                                  }
                              }
                          }
                      });
                  });
                  selectTableColumns.forEach(fieldObj => {
                      if (fieldObj.type === 'subform') {
                          // console.log(fieldObj);
                          // console.log(currentlinkFieldId);// 当前表单的关联字段id
                          targetFormFieldlist.forEach(element => {
                              // console.log('关联配置的关联字段ID:' + element.options.synLinkField);
                              if (element.options.dataSourceFieldId && element.options.dataSourceFieldId === currentlinkFieldId) {
                                  if (element.options.dataSourceSubFieldId) {
                                      if (element.options.dataSourceSubFieldId === fieldObj.id) {
                                          if (this.forms[index].fieldsList && this.forms[index].fieldsList.length > 0) {
                                              for (let i = 0; i < this.forms[index].fieldsList.length; i++) {
                                                  let tempField = this.forms[index].fieldsList[i];
                                                  if (element.id === tempField.id) {
                                                      this.$refs['fieldItemChild' + i][0].reSetSelectOptions(element, fieldObj, sourceData);
                                                  }
                                              }
                                          }
                                          // this.reSetSelectOptions(element, fieldObj, sourceData);
                                      }
                                  }
                              }
                          });
                      }
                  });
              }
              for (let i = 0; i < this.forms.length; i++) {
                  let form = this.forms[i];
                  let field = form.fieldsList.find(element => element.id === currentlinkFieldId);
                  if (field.options.ext2) {
                      let ext2 = field.options.ext2;
                      let ext2Obj = JSON.parse(ext2);
                      if (ext2Obj.automaticRecodeRefField) { // 配置了自动带出
                          let automaticRecodeFields = ext2Obj.automaticRecodeFields;
                          let automaticRecodeFieldsArray = automaticRecodeFields.split(',');
                          for (let i = 0; i < automaticRecodeFieldsArray.length; i++) {
                              let automaticRecodeFieldsItem = automaticRecodeFieldsArray[i];
                              let fieldObj = form.fieldsList.find(element => element.id === automaticRecodeFieldsItem);
                              if (fieldObj) {
                                  await this.getTableFirstRefData(fieldObj, form.fieldsList, index);
                              }
                          }
                      }
                  }
              }
          },
          async getTableFirstRefData (fieldObj, fieldsList, index) {
              let refTableData = [];
              let refTableColumn = [];
              this.searchParams.searchCondition = [];// 初始化搜索条件
              if (fieldObj.ext1 && this.searchParams.searchCondition.length === 0) { // 默认筛选值
                  let obj = JSON.parse(fieldObj.ext1);
                  this.defaultConditonsMap = new Map();
                  for (let key in obj) {
                      obj[key]['modelId'] = fieldObj.options.config.form.modelId;
                      this.searchParams.searchCondition.push(obj[key]);
                      this.defaultConditonsMap.set(obj[key].id, obj[key]);
                  }
                  this.searchCondition = this.searchParams.searchCondition;
              }
              // 任务表单内选择关联数据，默认从前3000条数据中进行筛选。
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              await this.setDefaultConditionRef(fieldObj);
              for (let i = 0; i < this.searchParams.searchCondition.length; i++) {
                  let defaultCondition = this.searchParams.searchCondition[i];
                  if (defaultCondition.operateType === 7) { // 从表单字段值取值搜索
                      let searchvalue = this.formData[defaultCondition.valueFieldId];
                      let cur = fieldsList.find(element => element.id === defaultCondition.valueFieldId);
                      let searchvalueView = '';
                      if (cur.type === 'category' || cur.type === 'select') {
                          searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                          let options = defaultCondition.options.config.options;
                          for (let i = 0; i < options.length; i++) {
                              let item = options[i];
                              if (item.title === searchvalueView) {
                                  searchvalue = item.value;
                              }
                          }
                      } else if (cur.type === 'department') {
                          searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                          searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-tree'];
                      } else if (cur.type === 'user') {
                          searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-user'];
                          searchvalueView = this.formData[index].values[defaultCondition.valueFieldId];
                      } else if (cur.type === 'link') {
                          searchvalue = this.formData[index].values[defaultCondition.valueFieldId + '-link'];
                          searchvalueView = this.formData[index].values[defaultCondition.valueFieldId + '-view'];
                      }
                      if (searchvalue) {
                          defaultCondition.conditionValue = searchvalue;
                          defaultCondition.conditionValueView = searchvalueView;
                          defaultCondition.operateType = 1;
                      }
                  }
              }
              // 处理关联字段值的搜索
              let formData = await getModelFormReportList({
                  currentPage: 1,
                  pageSize: 1,
                  modelId: fieldObj.options.config.form.modelId,
                  formId: fieldObj.options.config.form.formId,
                  isRelationSearch: true,
                  isFromFieldItemLink: true, // 是否进行关联字段的表单数据查询
                  processInstanceId: this.processInstanceId,
                  searchCondition: this.searchParams.searchCondition
              });
              if (formData.data) {
                  let tableDatas = [];
                  formData.data.forEach(item => {
                      let jsonObj = JSON.parse(item);
                      tableDatas.push(jsonObj);
                  });
                  refTableData = tableDatas;
                  loading.close();
              }
              if (formData.otherData) {
                  refTableColumn = formData.otherData.tableColumns;
              }
              //   this.loadTimer = new Date().getTime();
              if (fieldObj.options.config.form.selectTableHeaderFields) { // 配置了关联列表模型显示表头
                  let cacheTableColumns = [];
                  for (let i = 0; i < refTableColumn.length; i++) {
                      let cur = refTableColumn[i];
                      if (fieldObj.options.config.form.selectTableHeaderFields.indexOf(cur.id) !== -1) {
                          cacheTableColumns.push(cur);
                      }
                  }
                  refTableColumn = cacheTableColumns;
              }
              if (refTableData.length > 0) {
                  let param = {row: refTableData[0]};
                  this.handelSelectRefRow(param, fieldObj, refTableColumn, index);
              }
          },
          handelSelectRefRow (params, fieldObj, refTableColumn, index) { // TODO
              let selData = cloneDeep(params.row);
              let selectTableData = [selData];// 复制当前选中数据
              let linkData = this.setLinkTableData(refTableColumn, selectTableData[0]);
              let curFieldData = {
                  modelId: fieldObj.options.config.form.modelId,
                  tableColumns: refTableColumn,
                  tableData: [linkData]
              };
              this.formData[index].values[fieldObj.id] = curFieldData;
              this.formData[index].values[fieldObj.id + '-link'] = linkData.id;
              // this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[1].id];
              this.formData[index].values[fieldObj.id + '-view'] = linkData[refTableColumn[0].id];
          },
          setLinkTableData (selectTableColumns, sourceFormObj) { // 增加关联字段显示字段的冗余字段数据
              let linkData = {};
              if (sourceFormObj) {
                  linkData['id'] = sourceFormObj.id;
                  if (selectTableColumns && selectTableColumns.length > 0) {
                      let selectcolumns = cloneDeep(selectTableColumns);
                      // console.log(selectcolumns);
                      selectcolumns.forEach(item => {
                          if (item.type === 'dictionary' || item.type === 'businessTree' || item.type === 'department') {
                              // -tree
                              linkData[item.id] = sourceFormObj[item.id];
                              linkData[item.id + '-tree'] = sourceFormObj[item.id + '-tree'];
                          } else if (item.type === 'user') {
                              // -user
                              linkData[item.id] = sourceFormObj[item.id];
                              linkData[item.id + '-user'] = sourceFormObj[item.id + '-user'];
                          } else if (item.type === 'category' || item.type === 'select' || item.type === 'file' || item.type === 'process' || item.type === 'address' || item.type === 'cascader' || item.type === 'role') {
                              // -view
                              linkData[item.id] = sourceFormObj[item.id];
                              linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                          } else if (item.type === 'calculation' || item.type === 'number' || item.type === 'text' || item.type === 'serialNumber' || item.type === 'date') {
                              linkData[item.id] = sourceFormObj[item.id];
                          } else if (item.type === 'link') {
                              linkData[item.id + '-view'] = sourceFormObj[item.id + '-view'];
                          } else if (item.type === 'subform') {
                              linkData[item.id] = sourceFormObj[item.id];
                          }
                      });
                  }
              }
              return linkData;
          },
          async setDefaultConditionRef (fieldObj) {
              if (fieldObj.options.ext3 && fieldObj.options.ext3 === '1' && !isEmpty(this.defaultConditonsMap)) { // 设置过滤条件为固定模式
                  if (this.searchParams.searchCondition && Array.isArray(this.searchParams.searchCondition)) {
                      let defaultConditons = [];
                      this.searchParams.searchCondition.forEach(conditiontObj => {
                          if (this.defaultConditonsMap.has(conditiontObj.id)) {
                              let defaultCondition = this.defaultConditonsMap.get(conditiontObj.id);
                              if (defaultCondition && defaultCondition.conditionValue) {
                                  defaultConditons.push(defaultCondition);
                              } else {
                                  defaultConditons.push(conditiontObj);
                              }
                          } else {
                              defaultConditons.push(conditiontObj);
                          }
                      });
                      if (!isEmpty(defaultConditons)) {
                          this.searchParams.searchCondition = defaultConditons;
                      }
                  }
              }
              if (fieldObj.options.ext2) {
                  let def = JSON.parse(fieldObj.options.ext2);
                  if (def.linkConfig) {
                      let linkConfig = JSON.parse(def.linkConfig);
                      if (linkConfig.linkConfigState) { // 需要过滤数据
                          this.searchParams.searchCondition = [];
                          let key = linkConfig.id + '-link';
                          let value = this.formData[0].values[key];
                          let curObj = JSON.parse(linkConfig.linkFieldObj);
                          curObj.conditionValue = value;
                          if (linkConfig.type !== 'link') {
                              curObj.operateType = 2;
                          } else {
                              curObj.operateType = 7;
                          }
                          curObj.valueFieldId = linkConfig.id;
                          this.searchParams.searchCondition.push(curObj);
                      }
                  }
              }
              await this.setLinkLimitDataRef(fieldObj);
          },
          async setLinkLimitDataRef (fieldObj) {
              if (fieldObj.options.ext2) { // 子表单的值进行约束，例如只能查看自己作为项目成员参与的项目列表
                  let json = JSON.parse(fieldObj.options.ext2);
                  if (json.limitData === true && json.limitFieldDataArray && json.limitFieldDataArray.length > 0) {
                      let relateFormId = fieldObj.options.config.form.formId; // 关联字段的关联表单id
                      let formData = await getFormConfig(relateFormId);
                      if (formData) {
                          let fieldsList = formData.fieldsList;
                          if (fieldsList && fieldsList.length > 0) {
                              let conditonsMap = new Map();
                              for (let i = 0; i < json.limitFieldDataArray.length; i++) {
                                  let limitField = json.limitFieldDataArray[i];
                                  if (limitField.subFormFieldId) {
                                      let linkPropFieldId = limitField.linkPropFieldId;// 子表单字段
                                      let subFormFieldId = limitField.subFormFieldId;
                                      conditonsMap.set(linkPropFieldId, linkPropFieldId + ',' + subFormFieldId);
                                  }
                              }
                              for (let k = 0; k < fieldsList.length; k++) {
                                  let curfield = fieldsList[k];
                                  if (curfield.type === 'subform' && conditonsMap.has(curfield.id)) {
                                      let targetStr = conditonsMap.get(curfield.id);
                                      curfield.filterMainFieldId = targetStr.split(',')[0];
                                      curfield.filterSubField = targetStr.split(',')[1];
                                      this.searchParams.searchCondition.push(curfield);
                                  }
                              }
                          }
                      }
                  }
              }
          },
          isShowField () {
              let formInfo = this.formInfo.formObj.structure[0];
              if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                  for (var i = 0; i < formInfo.fieldsList.length; i++) {
                      let tempField = formInfo.fieldsList[i];
                      let tempRefName = 'fieldItemChild' + i;
                      if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                          setTimeout(() => {
                              // 设置下拉字段级联默认显示数据
                              if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                  this.$refs[tempRefName][0].renderFormRef();
                              }
                          }, 0);
                      }
                  }
              }
          },
          // 修改配置了关联映射的字段值
          updSynLinkFieldData (element, fieldObj, sourceData) {
              let type = fieldObj.type;
              let sourceValueKey = ''; // 对应userId等唯一性值
              let sourceValue = ''; // 级联显示从源数据中拉出来的字段值
              let can = false; // 是否支持级联显示
              let sourceDepartmentValueKey = ''; // 对应部门等唯一性值
              if (type === 'dictionary' || type === 'businessTree' || type === 'department') {
                  // -tree
                  can = true;
                  sourceDepartmentValueKey = sourceData[fieldObj.id];
                  sourceValue = sourceData[fieldObj.id + '-tree'];
              } else if (type === 'user') {
                  // -user
                  can = true;
                  sourceValueKey = sourceData[fieldObj.id];
                  sourceValue = sourceData[fieldObj.id + '-user'];
              } else if (type === 'category' || type === 'select' || type === 'file' || type === 'process' || type === 'address' || type === 'cascader' || type === 'role') {
                  // -view
                  can = true;
                  sourceValue = sourceData[fieldObj.id + '-view'];
                  sourceValueKey = sourceData[fieldObj.id];
                  if (element.options.synLinkFormField && element.options.synLinkFormField.type && element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi') {
                      let cacheValue = sourceData[fieldObj.id];
                      let cacheValueArray = [];
                      for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                          let cur = fieldObj.otherSetting.colorOne[i];
                          if (cacheValue.indexOf(cur.value) !== -1) {
                              cacheValueArray.push(cur.title);
                          }
                      }
                      sourceValue = cacheValueArray.join(',');
                  }
              } else if (type === 'calculation' || type === 'subFormSummary' || type === 'number' || type === 'text' || type === 'serialNumber' || type === 'date') {
                  can = true;
                  sourceValue = sourceData[fieldObj.id];
              } else if (type === 'link') {
                  can = true;
                  sourceValue = sourceData[fieldObj.id + '-view'];
              } else if (type === 'subform') {
                  can = true;
                  sourceValue = sourceData[fieldObj.id];
                  console.log(sourceValue);
              }
              if (can) {
                  if (element.type === 'text') {
                      this.formData[0].values[element.id] = sourceValue;
                      this.formData[0].values[element.id + '-view'] = '';
                  } else if (element.type === 'number' || element.type === 'calculation') {
                      if (!isEmpty(sourceValue)) {
                          this.formData[0].values[element.id] = sourceValue;
                          this.formData[0].values[element.id + '-view'] = '';
                      } else {
                          this.formData[0].values[element.id] = '';
                          this.formData[0].values[element.id + '-view'] = '';
                      }
                      this.refreshViewField();
                  } else if (element.type === 'user') {
                      if (!isEmpty(sourceValue)) {
                          this.formData[0].values[element.id] = sourceValueKey;
                          this.formData[0].values[element.id + '-user'] = sourceValue;
                      } else {
                          this.formData[0].values[element.id] = '';
                          this.formData[0].values[element.id + '-user'] = '';
                      }
                      this.refreshViewField();
                  } else if (element.type === 'department') {
                      if (!isEmpty(sourceValue)) {
                          this.formData[0].values[element.id] = sourceDepartmentValueKey;
                          this.formData[0].values[element.id + '-tree'] = sourceValue;
                      } else {
                          this.formData[0].values[element.id] = '';
                          this.formData[0].values[element.id + '-tree'] = '';
                      }
                      this.refreshViewField();
                  } else if (element.type === 'select') {
                      if (!isEmpty(sourceValue)) {
                          // 下拉选项值
                          let targetFieldValue = {};
                          let targetFieldOptions = element.options.config.options;
                          for (let i = 0; i < fieldObj.options.config.options.length; i++) { // 解决修改了字段的tit后老的数据无法对应name的情况
                              let o = fieldObj.options.config.options[i];
                              if (o.value === sourceValueKey) {
                                  sourceValue = o.title;// 获取最新的title
                                  break;
                              }
                          }
                          for (let i = 0; i < targetFieldOptions.length; i++) {
                              let optionItem = targetFieldOptions[i];
                              if (optionItem.title === sourceValue || optionItem.value === sourceValueKey) {
                                  targetFieldValue = optionItem;
                                  break;
                              }
                          }
                          if (targetFieldValue) {
                              this.formData[0].values[element.id] = targetFieldValue.value;
                              this.formData[0].values[element.id + '-view'] = targetFieldValue.title;
                          }
                          let formInfo = this.formInfo.formObj.structure[0];
                          if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                              this.loadTimerField = new Date().getTime();
                              for (var i = 0; i < formInfo.fieldsList.length; i++) {
                                  let tempField = formInfo.fieldsList[i];
                                  let tempRefName = 'fieldItemChild' + i;
                                  if ((tempField.type === 'select' || (tempField.type === 'category' && tempField.options.config.type === 'single')) && tempField.ext2 !== '1') {
                                      if (tempField.id === element.id) {
                                          setTimeout(() => {
                                          // 设置下拉字段级联默认显示数据
                                              if (this.$refs[tempRefName] && this.$refs[tempRefName][0]) {
                                                  this.$refs[tempRefName][0].setCascadeData();
                                              }
                                          }, 0);
                                      }
                                  }
                              }
                          }
                      } else {
                          this.formData[0].values[element.id] = '';
                          this.formData[0].values[element.id + '-view'] = '';
                      }
                  } else if (element.type === 'subform') {
                      //   let sourceSubColumns = fieldObj.subColumns;
                      let sourceSubColumns = fieldObj.options.fieldList;
                      let taragetSubColumns = element.options.fieldList;
                      let newValue = [];
                      if (sourceSubColumns && !isEmpty(sourceValue)) {
                          for (let i = 0; i < sourceValue.length; i++) {
                              let sourceItemValue = sourceValue[i];
                              let targetItemValue = {};
                              for (let j = 0; j < taragetSubColumns.length; j++) { // 寻找同名的字段，然后获取其值付给目标字段
                                  let targetColumn = taragetSubColumns[j];
                                  for (let k = 0; k < sourceSubColumns.length; k++) {
                                      let sourceColumn = sourceSubColumns[k];
                                      if (targetColumn.label === sourceColumn.name || targetColumn.name === sourceColumn.name) {
                                          if (sourceColumn.type === 'dictionary' || sourceColumn.type === 'businessTree' || sourceColumn.type === 'department') {
                                              // -tree
                                              targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-tree'];
                                          } else if (sourceColumn.type === 'user') {
                                              // -user
                                              targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-user'];
                                          } else if (sourceColumn.type === 'category' || sourceColumn.type === 'select' || sourceColumn.type === 'file' || sourceColumn.type === 'process' || sourceColumn.type === 'address' || sourceColumn.type === 'cascader' || sourceColumn.type === 'role') {
                                              // -view
                                              targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id + '-view'];
                                              if (element.options.synLinkFormField.type === 'category' && element.options.synLinkFormField.options.config.type === 'multi') {
                                                  let cacheValue = sourceData[fieldObj.id];
                                                  let cacheValueArray = [];
                                                  for (let i = 0; i < fieldObj.otherSetting.colorOne.length; i++) {
                                                      let cur = fieldObj.otherSetting.colorOne[i];
                                                      if (cacheValue.indexOf(cur.value) !== -1) {
                                                          cacheValueArray.push(cur.title);
                                                      }
                                                  }
                                                  targetItemValue[targetColumn.id] = cacheValueArray.join(',');
                                              }
                                          } else if (sourceColumn.type === 'calculation' || sourceColumn.type === 'number' || sourceColumn.type === 'text' || sourceColumn.type === 'serialNumber' || sourceColumn.type === 'date') {
                                              targetItemValue[targetColumn.id] = sourceItemValue[sourceColumn.id];
                                          }
                                          break;
                                      }
                                  }
                              }
                              if (!isEmpty(targetItemValue)) {
                                  newValue.push(targetItemValue);
                              }
                          }
                          console.log(newValue);
                          this.formData[0].values[element.id] = newValue;
                      } else {
                          this.formData[0].values[element.id] = '';
                      }
                  }
              }
              this.formData[0].values = cloneDeep(this.formData[0].values);
          },
          asynFormUserFieldData (key, value) {
              this.formData[0].values[key] = value;
              this.loadTimerField = new Date().getTime();
          },
          async refreshViewField (relateModelMap) {
              if (relateModelMap && relateModelMap.size > 0) { // 级联显示子表单控制
                  this.relateModelMap = new Map();
                  this.relateModelMap = relateModelMap;
                  if (this.relateModelList) {
                      for (let i = 0; i < this.relateModelList.length; i++) {
                          let model = this.relateModelList[i];
                          if (relateModelMap.has(model.id)) {
                              model.hiddenElement = !relateModelMap.get(model.id);
                              //   this.showRelateFormTab = relateModelMap.get(model.id);
                              if (relateModelMap.get(model.id)) {
                                  this.showRelateFormTab = true;
                                  //   await this.renderModelFormList(model);
                              }
                              //   if (this.showRelateFormTab) {
                              //       await this.renderModelFormList(model);
                              //   }
                          }
                      }
                      for (let i = 0; i < this.relateModelList.length; i++) {
                          let cur = this.relateModelList[i];
                          if (!cur.hiddenElement) {
                              this.relateFormTabName = cur.id;
                              await this.renderModelFormList(cur);
                              break;
                          }
                      }
                  }
              } else {
                  this.loadTimerField = new Date().getTime();
              }
          },
          async handelShowDiagram () { // 显示流程图
              await this.setProcessViewInfo(this.processInstanceId);
              this.isShowDiagram = true;
              setTimeout(() => {
                  // 调用子组件的方法
                  this.$refs.diagrams.setProcessState(false);
                  this.$refs.diagrams.resetDiagramUrl();
              }, 0);
          },
          async setProcessViewInfo (businessInstanceId) {
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              this.instances = await getProcessInstancesDetail(businessInstanceId);
              let tasks = await getAllUserTask(this.instances.id, this.instances.processServiceId, null, this.instances.deploymentId);
              this.taskList = tasks;
              let treeList = [];
              if (this.instances.archiveTemplateId) {
                  treeList = await getArchiveTemplateTreeList({templateId: this.instances.archiveTemplateId});
              }
              this.archiveTemplateTreeList = treeList;
              loading.close();
          },
          handleSelectFromHis (index, form) {
              this.loadTimer = new Date().getTime();
              this.formIndex = index;
              this.currentModelId = form.modelId;
              this.isShowDataCopyDialog = true;
          },
          reSetProcessFormData (data) { // 选择好复制的数据后，重置流程表单数据
              let selectValues = clone(data);
              if (selectValues.hasOwnProperty('id')) {
                  delete selectValues.id;
              }
              this.formData[this.formIndex].values = selectValues;
              this.refreshViewField();
              this.isShowDataCopyDialog = false;
          },
          handleFromDataFilter (index, form) {
              this.loadTimer = new Date().getTime();
              this.formIndex = index;
              this.currentModelId = form.modelId;
              this.isShowDataFilterDialog = true;
          },
          async showQR (obj) {
              let instance = JSON.parse(this.formInfo.formObj.instance);
              // let domain = document.domain;
              let qrPre = '/download/image?filePath=';
              // if (domain.indexOf('bcbpm.com') !== -1) {
              //     qrPre = '/bcbpm' + qrPre;
              // }
              let env = process.env.NODE_ENV;
              if (env === 'production') {
                  qrPre = '/bcbpm' + qrPre;
              }
              if (instance.qrpath) {
                  this.imageKey = new Date().getTime();
                  this.qrUrl = qrPre + instance.qrpath;
                  // console.log(this.qrUrl);
              } else {
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  let param = {id: this.id, formName: obj.formName, modelId: obj.modelId};
                  let res = await getModelFormInstanceQR(param);
                  loading.close();
                  if (res && res.filePath) {
                      this.imageKey = new Date().getTime();
                      this.qrUrl = qrPre + res.filePath;
                      // console.log(this.qrUrl);
                      this.qrTit = '二维码';
                  }
              }
          },
          handleSubFormView (index) {
              let subFormViewMode = this.formData[index].values['subFormViewMode'];
              if (!subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                  subFormViewMode = 1;
              } else {
                  subFormViewMode = 0;
              }
              // console.log(subFormViewMode);
              this.formData[index].values['subFormViewMode'] = subFormViewMode;
              this.refreshViewField();
          },
          getSubformName (formData, field) {
          // formData[field.id + '-view'];
              // console.log(formData);
              // console.log(field);
              // console.log(formData[field.id]);
              if (Array.isArray(formData[field.id])) {
                  return field.name + '(' + formData[field.id].length + ')';
              } else {
                  return field.name + '(0)';
              }
          },
          isShowCascadeField (field, values) {
              return isFormFieldVisible(field, values);
          },
          isShowNormalField (field, index, formData) {
              if (!field || !formData || !formData.values || !isFormFieldVisible(field, formData.values)) {
                  return false;
              }
              let subFormViewMode = formData.values['subFormViewMode'];
              if (subFormViewMode !== 0 && (formData.ext1 === 1 || subFormViewMode === 1)) { // 子表单页签模式
                  if (field.type === 'subform') {
                      return false;
                  } else {
                      return true;
                  }
              } else if (formData.ext1 === 0 || !subFormViewMode || subFormViewMode === 0) { // 子表单正常模式
                  return true;
              }
          },
          async getModelListByMainFormId (init) {
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              let modelList = await getModelListByMainFormId(this.formInfo.formId);
              this.relateModelList = modelList;
              if (this.relateModelList && this.relateModelList.length > 0) {
                  // for (let i = 0; i < this.relateModelList.length; i++) {
                  //     let relateModel = this.relateModelList[i];
                  //     if (relateModel.relateModelRequired) {
                  //         relateModel.modelName = '(必填)' + relateModel.modelName;
                  //     }
                  // }
                  if (init) {
                      this.refreshViewField(this.relateModelMap);
                  }
                  this.showRelateFormTab = true;
                  // 默认打开第一个关联表单数据
                  this.relateFormTabName = this.relateModelList[0].id;
                  this.renderModelFormList(this.relateModelList[0]);
              } else {
                  this.showRelateFormTab = false;
              }
              loading.close();
          },
          async renderModelFormList (model) {
              if (this.relateModelMap && this.relateModelMap.has(model.id)) {
                  this.showRelateFormTab = this.relateModelMap.get(model.id);
              }
              // console.log(this.showRelateFormTab);
              if (this.showRelateFormTab) {
              // 主表的formid
                  model.mainFormId = this.formInfo.formId;
                  // 主表当前数据id
                  model.mainFormDataId = this.id;
                  // this.loadTimerRelate = new Date().getTime();
                  this.$nextTick(_ => {
                      setTimeout(() => { // 调用子组件的方法
                          if (this.$refs['relateModelList' + model.id] && this.$refs['relateModelList' + model.id].length > 0) {
                              this.$refs['relateModelList' + model.id][0].renderFormList(model);
                          }
                      }, 0);
                  });
              }
          },
          handleRelateFormTabClick (tab, event) {
              // console.log(tab.name);
              this.relateFormTabName = tab.name;
              for (var i = 0; i < this.relateModelList.length; i++) {
                  let model = this.relateModelList[i];
                  // console.log(model.id);
                  if (model.id === this.relateFormTabName) {
                      this.renderModelFormList(model);
                  }
              }
          },
          async numberValidate (field, formData) {
              let isRefuse = false;
              let formulaExp = field.options.formulaExp;
              // console.log(formulaExp);
              let ifPass = await this.chkPassRule(formulaExp, formData);
              // console.log(ifPass);
              if (formulaExp && !ifPass) {
                  isRefuse = true;
              }
              return isRefuse;
          },
          async chkPassRule (formulaExp, formData) {
              let arr = [];
              if (formulaExp.indexOf('>=') !== -1) {
                  arr = formulaExp.split('>=');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] >= arr[1]) {
                      return true;
                  }
              } else if (formulaExp.indexOf('<=') !== -1) {
                  arr = formulaExp.split('<=');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] <= arr[1]) {
                      return true;
                  }
              } else if (formulaExp.indexOf('>') !== -1) {
                  arr = formulaExp.split('>');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] > arr[1]) {
                      return true;
                  }
              } else if (formulaExp.indexOf('<') !== -1) {
                  arr = formulaExp.split('<');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] < arr[1]) {
                      return true;
                  }
              } else if (formulaExp.indexOf('!=') !== -1) {
                  arr = formulaExp.split('!=');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] !== arr[1]) {
                      return true;
                  }
              } else if (formulaExp.indexOf('=') !== -1) {
                  arr = formulaExp.split('=');
                  arr = await this.dealArr(arr, formData);
                  if (arr[0] != null && arr[1] != null && arr[0] === arr[1]) {
                      return true;
                  }
              }
              return false;
          },
          async dealArr (arr, formData) {
              for (var i = 0; i < arr.length; i++) {
                  let tempKey = arr[i];
                  if ((tempKey.indexOf(';') !== -1) || (tempKey.indexOf(',') !== -1)) {
                      let param = {};
                      param.valuesNode = formData;
                      param.formulaExp = tempKey;
                      let res = await getCrossFieldData(param);
                      if (res && res.finalVal) {
                          arr[i] = Number(res.finalVal);
                      } else {
                          arr[i] = null;
                      }
                  } else {
                      arr[i] = formData[tempKey] ? Number(formData[tempKey]) : !Number.isNaN(tempKey) ? Number(tempKey) : null;
                  }
              }
              // console.log(arr);
              return arr;
          },
          activeClass (item) {
              if (item.stepStatus === 1) {
                  return 'success-step';
              } else if (item.stepStatus === 2) {
                  return 'reject-step';
              } else if (item.stepStatus === 99) {
                  return 'now-step';
              } else {
                  return '';
              }
          },
          activeUserClass (item) {
              if (item.stepStatus === 1) {
                  return 'success-user';
              } else if (item.stepStatus === 2) {
                  return 'reject-user';
              } else if (item.stepStatus === 99) {
                  return 'now-user';
              } else {
                  return '';
              }
          },
          async handleApprovalDetail () {
              this.rightActive = 1;
              if (this.currentRowData && this.currentRowData.approvalInstanceId) {
                  this.approvalDetail = await getApprovalInstanceDetail(this.currentRowData.approvalInstanceId);
                  if (this.approvalDetail.approvalStatus === 2) { // 审批通过
                      this.forms[0].fieldsList.forEach(element => {
                          let ext2 = element.options.ext2;
                          if (ext2) {
                              let ext2Obj = JSON.parse(ext2);
                              if (ext2Obj.approveDisEditFieldAuth && ext2Obj.approveDisEditFieldAuth === '1') {
                                  element.isRead = true;
                              }
                          }
                      });
                  }
              } else {
                  // 判断是否主子表，找到link的数据查找审批状态
                  let apprFla = false;
                  for (let i = 0; i < this.forms[0].fieldsList.length; i++) {
                      let element = this.forms[0].fieldsList[i];
                      let ext2 = element.options.ext2;
                      if (ext2) {
                          let ext2Obj = JSON.parse(ext2);
                          if (ext2Obj.approveDisEditFieldAuth && ext2Obj.approveDisEditFieldAuth === '1') { // 配置了审批通过后不能修改的字段
                              if (apprFla) { // 已经请求过后端了
                                  if (this.approvalDetail.approvalStatus === 2) {
                                      element.isRead = true;
                                  }
                              } else {
                                  let res = await this.getMainApproveData();
                                  if (res) { // 审批通过了
                                      element.isRead = true;
                                  }
                                  apprFla = true;
                              }
                          }
                      }
                  }
                  this.loadTimerField = new Date().getTime();
              }
          },
          async getMainApproveData () {
              for (let i = 0; i < this.forms[0].fieldsList.length; i++) {
                  let element = this.forms[0].fieldsList[i];
                  if (element.type === 'link') {
                      let id = this.formData[0].values[element.id + '-link'];
                      let linkDataInfo = await getModelFormInstanceById(id);
                      if (linkDataInfo && linkDataInfo.approvalInstanceId) {
                          this.approvalDetail = await getApprovalInstanceDetail(linkDataInfo.approvalInstanceId);
                          if (this.approvalDetail && this.approvalDetail.approvalStatus !== 2) { // 存在审批未通过的主表
                              return false;
                          }
                      }
                  }
              }
              return true;
          },
          cacheData () {
              setTimeout(() => {
                  let structure = this.formInfo.formObj.structure[0];
                  let modelId = structure.modelId;
                  let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                  let currentUserInfo = JSON.parse(currentUserStr);
                  let key = currentUserInfo.userId + modelId;
                  let value = JSON.stringify(this.formData);
                  window.localStorage.setItem(key, value);
                  this.cacheData();
              }, 10000);
          },
          setRealTimeSaveData (time) {
              if (this.isTimer) {
                  let timing = time * 1000;
                  let formInfo = this.formInfo.formObj.structure[0];
                  if (this.formData && this.formData.length > 0) {
                      let param = {forms: this.formData, modelId: formInfo.modelId, tempFormData: this.tempFormData};
                      let setTim = setTimeout(async () => {
                          if (!objectKeyIsEmpty(this.formData[0].values, this.formData[0].attributes)) {
                              let res = await saveAppModelForm(this.modelId, param);
                              if (res && res.id) {
                                  this.formData[0].values.id = res.id;
                              }
                          }
                          this.setRealTimeSaveData(time);
                      }, timing);
                      this.setTim.push(setTim);
                  } else {
                      let setTim = setTimeout(async () => {
                          this.setRealTimeSaveData(time);
                      }, timing);
                  }
              }
          },
          clearTimeOut () {
              this.isTimer = false;
              if (this.setTim.length > 0) {
                  for (let i = 0; i < this.setTim.length; i++) {
                      let cur = this.setTim[i];
                      clearTimeout(cur);
                  }
              }
          },
          closeModelDetail () {
              this.$emit('closeModelDetail');
          },
          verifySpecialField (currentId) {
              this.$nextTick(() => {
                  let inputDomArr = document.getElementsByClassName('el-form-item is-error is-required');
                  for (let i = 0; i < inputDomArr.length; i++) {
                      let labelTemp = inputDomArr[i].getElementsByTagName('label');
                      if (labelTemp && labelTemp.length > 0) {
                          let id = labelTemp[0].getAttributeNode('for').value; // 取出第一个label参数for的值
                          if (id === currentId) {
                              inputDomArr[i].getElementsByClassName('el-form-item__content')[0].classList.add('requiredExtClass');
                              break;
                          }
                      }
                  }
              });
          },
          dealRequiredSpecialField (currentId) {
              this.verifySpecialField(currentId);
              this.$nextTick(() => {
                  let inputDomArr = document.getElementsByClassName('el-form-item is-success is-required');
                  for (let i = 0; i < inputDomArr.length; i++) {
                      let labelTemp = inputDomArr[i].getElementsByTagName('label');
                      if (labelTemp && labelTemp.length > 0) {
                          let id = labelTemp[0].getAttributeNode('for').value; // 取出第一个label参数for的值
                          if (id === currentId) {
                              inputDomArr[i].getElementsByClassName('el-form-item__content')[0].classList.remove('requiredExtClass');
                              break;
                          }
                      }
                  }
              });
          },
          dealSpecialField (fieldId) {
              this.$refs['customForm0'][0].validateField(fieldId);
              this.dealRequiredSpecialField(fieldId);
          },
          refTempFormData (obj) {
              this.renderCalculationField(obj);
          },
          async renderCalculationField (tempFormData) { // 主子表情况下，主表里有计算字段使用了子表的数据，还没提交后台时提前计算逻辑
              if (this.forms && this.forms.length > 0) {
                  let formInfo = this.forms[0];// 默认第一个
                  let isRefresh = false;
                  if (formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                      for (var i = 0; i < formInfo.fieldsList.length; i++) {
                          let tempField = formInfo.fieldsList[i];
                          // console.log(tempField);
                          if (tempField.type === 'calculation' && tempField.isView && tempField.ext2 !== '1') {
                              let param = {};
                              param.valuesNode = this.formData[0].values;
                              param.formulaExp = tempField.options.formulaExp;
                              param.tempFormData = tempFormData;
                              let res = await getCrossFieldData(param);
                              let finalVal = null;
                              if (res && res.finalVal) {
                                  finalVal = Number(res.finalVal);
                                  this.formData[0].values[tempField.id] = finalVal;
                                  isRefresh = true;
                              }
                          }
                      }
                      if (isRefresh) {
                          this.loadTimerField = new Date().getTime();
                      }
                  }
              }
          },
          showRight() {
              if (this.approvalDetail.approVoList) {
                  this.rightActive = 1;
              } else {
                  this.rightActive = 2;
              }
              this.isShowRight = !this.isShowRight;
          }
      }
  };
</script>

<style lang="less">
  .popEditModelDetail{
        .el-dialog {
            .el-dialog__body{
                padding: 0px;
                height: ~"calc(100% - 30px)" !important;
            }
        }
   }
  .busi-modelDetail {
      width: 100%;
      height: 100%;
      margin-top: -3%;
      background: #f9fbfc;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .model-top{
        background: #fff;
        width: 100%;
        height: 10vh;
        line-height: 10vh;
        display: flex;
        align-items: center;
        @media screen and (min-width: 1024px) and (max-width: 1366px) {
            height: 8vh;
            line-height: 8vh;
        }
        .tit{
            display: flex;
            width: 30vw;
            justify-content: start;
            align-items: center;
            padding-left: 20px;
            height: 100%;
            margin-top: 2.5vh;
        }
        .btns{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: end;
            padding-right: 60px;
            margin-top: 2.5vh;
            height: 100%;
            div{
                display: flex;
            }
        }
      }
      .model-content{
        flex: 1;
        margin-top: 6px;
        width: 100%;
        display: flex;
        flex-direction: row;
        overflow: auto;
        .content-left{
            flex: 1;
            overflow: auto;
            overflow: auto;
            background: #fff;
            padding-top: 10px;
        }
        .content-switch{
            .content-right-close{
                margin-left: -16px !important;
            }
            .content-right-open{
                margin-left: -4px !important;
            }
        }
        .content-right{
            width: 22vw;
            background: #fff;
            margin-left: 4px;
            padding-left: 20px;
            display: flex;
            flex-direction: column;
            .content-right-tit{
                display: flex;
                border-bottom: 1px solid #e2e0e0;
                height: 60px;
                line-height: 60px;
                justify-content: center;
                align-items: center;
                .tit-approve,.tit-uprecord{
                    font-size: 20px;
                    flex: 1;
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .tit-uprecord{
                   margin-right: 40px;
                }
                .activeTit{
                    color: #AB271A;
                    .line{
                        width: 30px;
                        border: 2px solid #AB271A;
                        border-radius: 2px;
                    }
                }
            }
            .content-right-content{
                flex: 1;
                .content-approve{
                    display: flex;
                    position: relative;
                    height: 100%;
                    flex-direction: column;
                    .approve-title{
                        font-size: 20px;
                        font-weight: 700;
                        margin-top: 10px;
                        color: #333;
                        max-height: 300px;
                        height: auto;
                        cursor: pointer;
                    }
                    .approve-info{
                        flex: 1;
                        margin-top: 10px;
                    }
                }
                .content-uprecord{
                    position: relative;
                    height: 100%;
                    flex-direction: column;
                    .uprecord-item{
                        // margin-top: 20px;
                        background: #fff;
                        font-size: 16px;
                        display: flex;
                        .left{
                            width: 30px;
                            display: flex;
                            margin-top: 20px;
                            position: relative;
                            left: -8px;
                            padding-top: 8px;
                            .dot{
                                width: 12px;
                                height: 12px;
                                border-radius: 12px;
                                background: rgb(187, 188, 190);
                                position: relative;
                                left: 6px;
                            }
                            .line{
                                flex: 1;
                                border-left: 1px solid  rgb(187, 188, 190);
                                height: ~"calc(100% + 30px)";
                                // height: 100%;
                            }
                        }
                        .right{
                            flex: 1;
                            .item-bottom{
                                .top{
                                    height: 20px;
                                    background: #fff;
                                }
                                .bottom{
                                    line-height: 26px;
                                    font-weight: 600;
                                    margin-top: 10px;
                                    background: rgb(249, 249, 249);
                                    padding: 10px;
                                    border-radius: 4px;
                                    .item-top{
                                        display: flex;
                                        .upUser{
                                            font-weight: 700;
                                            flex: 1;
                                        }
                                        .upTime{
                                            flex: 1;
                                            text-align: right;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }

      }
      .el-collapse-item__wrap {
          padding: 0 20px;
          height: ~"calc(100% - 6vh)";
          overflow: auto;
          padding-bottom: 2vh;
      }

      .el-collapse {
          width: 100%;
          .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
            margin-bottom:5px
          }
      }

      .el-form {
          width: 100%;
          .el-cascader--small,.el-select--small{
              width: 100%;
          }
          .render-form-item{
              .el-row{
                  display: flex;
                  .subform-field-item{
                      width: 100%;
                  }
              }
              .relateFormTab {
                  .el-tabs__header {
                      margin: 0 0 2px;
                  }
              }
          }
      }

      .model-btns {
          height: 80px;
          padding: 0 10px 0 0;
      }
      .comments {
          width: 300px;
      }
      .collapseItem{
         width: 100%;
         height: 100%;
         overflow: hidden;
      }
      .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a;
              .is-success{
                  color: #67c23a;
                  border-color: #67c23a;
              }
          }
          .el-breadcrumb__inner{
                  color: #c0c4cc;
                  .is-success{
                      color: #67c23a;
                      border-color: #67c23a;
                  }
          }
          .success-user .el-breadcrumb__inner{
              color: #67c23a;
          }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
              position: absolute;
              border-color: inherit;
              background-color: #67c23a;
              color: #67c23a;
          }
      }
      .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c;
          }
          .el-breadcrumb__inner{
                  color: #c0c4cc;
          }
          .reject-user .el-breadcrumb__inner{
              color: #f56c6c;
          }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
      }
      .now-step{
          .el-step__head{
              color: #409eff;
              border-color: #409eff;
              .is-success{
                  color: #409eff;
                  border-color: #409eff;
              }
          }
          .el-breadcrumb__inner{
                  color: #409eff;
                  border-color: #409eff;
                  .is-success{
                      color: #409eff;
                      border-color: #409eff;
                  }
              }
          .el-step__title{
              color: #409eff;
              .is-process{
                  font-weight: 700;
              }
          }
          .el-step__line {
              position: absolute;
              border-color: inherit;
              background-color: #409eff;
              color: #409eff;
          }
      }
  }
  .el-popover {
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/ModelDetail.vue